var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteDriverSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 92,
    viewBox: "0 0 70 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48926 52.7949L5.52976 90.8484L69.4948 90.7877L69.4543 52.8556L37.7451 71.7812L5.48926 52.7949Z",
    stroke: "#04DFEA",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4941 91.0302V52.3694L37.5014 19.1738L5.50879 52.3694V90.8075C5.50879 90.8075 69.5953 91.1314 69.4941 91.0302Z",
    stroke: "#04DFEA",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82957 54.4921L37.6027 71.2113L8.82957 54.4921ZM66.0722 29.0488L65.8494 54.3301V54.5325L37.5825 71.5149L37.5015 71.4744L8.52584 54.6337V54.5933L8.14111 29.1703",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3199 61.5996C44.1234 61.5996 49.631 56.094 49.631 49.293C49.631 42.4919 44.1234 36.9863 37.3199 36.9863C30.5164 36.9863 25.0088 42.4919 25.0088 49.293C25.0088 56.094 30.5164 61.5996 37.3199 61.5996Z",
    fill: "#1400D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9274 55.3601L36.1343 55.567L36.3064 55.3302L45.0132 43.3474L45.0253 43.3307L45.0345 43.3123C45.036 43.3094 45.0378 43.3061 45.0423 43.2982L45.0434 43.2963C45.0473 43.2896 45.0552 43.276 45.0624 43.2617C45.0822 43.222 45.1014 43.1683 45.1014 43.0993V43.0991V43.099V43.0989V43.0988V43.0987V43.0985V43.0984V43.0983V43.0982V43.098V43.0979V43.0978V43.0977V43.0975V43.0974V43.0973V43.0972V43.097V43.0969V43.0968V43.0967V43.0965V43.0964V43.0963V43.0961V43.096V43.0959V43.0958V43.0956V43.0955V43.0954V43.0952V43.0951V43.095V43.0948V43.0947V43.0946V43.0944V43.0943V43.0941V43.094V43.0939V43.0937V43.0936V43.0935V43.0933V43.0932V43.093V43.0929V43.0928V43.0926V43.0925V43.0923V43.0922V43.0921V43.0919V43.0918V43.0916V43.0915V43.0913V43.0912V43.091V43.0909V43.0908V43.0906V43.0905V43.0903V43.0902V43.09V43.0899V43.0897V43.0896V43.0894V43.0893V43.0891V43.089V43.0888V43.0887V43.0885V43.0884V43.0882V43.0881V43.0879V43.0877V43.0876V43.0874V43.0873V43.0871V43.087V43.0868V43.0867V43.0865V43.0863V43.0862V43.086V43.0859V43.0857V43.0855V43.0854V43.0852V43.0851V43.0849V43.0847V43.0846V43.0844V43.0843V43.0841V43.0839V43.0838V43.0836V43.0834V43.0833V43.0831V43.0829V43.0828V43.0826V43.0824V43.0823V43.0821V43.0819V43.0818V43.0816V43.0814V43.0813V43.0811V43.0809V43.0808V43.0806V43.0804V43.0803V43.0801V43.0799V43.0797V43.0796V43.0794V43.0792V43.079V43.0789V43.0787V43.0785V43.0783V43.0782V43.078V43.0778V43.0776V43.0775V43.0773V43.0771V43.0769V43.0768V43.0766V43.0764V43.0762V43.076V43.0759V43.0757V43.0755V43.0753V43.0751V43.075V43.0748V43.0746V43.0744V43.0742V43.0741V43.0739V43.0737V43.0735V43.0733V43.0731V43.073V43.0728V43.0726V43.0724V43.0722V43.072V43.0718V43.0717V43.0715V43.0713V43.0711V43.0709V43.0707V43.0705V43.0703V43.0701V43.07V43.0698V43.0696V43.0694V43.0692V43.069V43.0688V43.0686V43.0684V43.0682V43.0681V43.0679V43.0677V43.0675V43.0673V43.0671V43.0669V43.0667V43.0665V43.0663V43.0661V43.0659V43.0657V43.0655V43.0653V43.0651V43.0649V43.0647V43.0645V43.0643V43.0641V43.064V43.0638V43.0636V43.0634V43.0632V43.063V43.0628V43.0626V43.0624V43.0622V43.062V43.0618V43.0616V43.0614V43.0612V43.0609V43.0607V43.0605V43.0603V43.0601V43.0599V43.0597V43.0595V43.0593V43.0591V43.0589V43.0587V43.0585V43.0583V43.0581V43.0579V43.0577V43.0575V43.0573V43.0571V43.0569V43.0567V43.0564V43.0562V43.056V43.0558V43.0556V43.0554V43.0552V43.055V43.0548V43.0546V43.0544V43.0542V43.0539V43.0537V43.0535V43.0533V43.0531V43.0529V43.0527V43.0525V43.0523V43.052V43.0518V43.0516V43.0514V43.0512V43.051V43.0508V43.0506V43.0503V43.0501V43.0499V43.0497V43.0495V43.0493V43.0491V43.0488V43.0486V43.0484V43.0482V43.048V43.0478V43.0475V43.0473V43.0471V43.0469V43.0467V43.0465V43.0462V43.046V43.0458V43.0456V43.0454V43.0452V43.0449V43.0447V43.0445V43.0443V43.0441V43.0438V43.0436V43.0434V43.0432V43.043V43.0427V43.0425V43.0423V43.0421V43.0419V43.0416V43.0414V43.0412V43.041V43.0408V43.0405V43.0403V43.0401V43.0399V43.0396V43.0394V43.0392V43.039V43.0387V43.0385V43.0383V43.0381V43.0379V43.0376V43.0374V43.0372V43.037V43.0367V43.0365V43.0363V43.0361V43.0358V43.0356V43.0354V43.0352V43.0349V43.0347V43.0345V43.0343V43.034V43.0338V43.0336V43.0333V43.0331V43.0329V43.0327V43.0324V43.0322V43.032V43.0318V43.0315V43.0313V43.0311V43.0308V43.0306V43.0304V43.0302V43.0299V43.0297V43.0295V43.0292V43.029V43.0288V43.0286V43.0283V43.0281V43.0279V43.0276V43.0274V43.0272V43.0269V43.0267V43.0265V43.0262V43.026V43.0258V43.0256V43.0253V43.0251V43.0249V43.0246V43.0244V43.0242V43.0239V43.0237V43.0235V43.0232V43.023V43.0228V43.0225V43.0223V43.0221V43.0218V43.0216V43.0214V43.0211V43.0209V43.0207V43.0205V43.0202V43.02V43.0198V43.0195V43.0193V43.0191V43.0188V43.0186V43.0183V43.0181V43.0179V43.0176V43.0174V43.0172V43.0169V43.0167V43.0165V43.0162V43.016V43.0158V43.0155V43.0153V43.0151V43.0148V43.0146V43.0144V43.0141V43.0139V43.0137V43.0134V43.0132V43.013V43.0127V43.0125V43.0122V43.012V43.0118V43.0115V43.0113V43.0111V43.0108V43.0106V43.0104V43.0101V43.0099V43.0097V43.0094V43.0092V43.0089V43.0087V43.0085V43.0082V43.008V43.0078V43.0075V43.0073V43.0071V43.0068V43.0066V43.0063V43.0061V43.0059V43.0056V43.0054V43.0052V43.0049V43.0047V43.0044V43.0042V43.004V43.0037V43.0035V43.0033V43.003V43.0028V43.0026V43.0023V43.0021V43.0018V43.0016V43.0014V43.0011V43.0009V43.0007V43.0004V43.0002V42.9999V42.9997V42.9995V42.9992V42.999V42.9988V42.9985V42.9983V42.998C45.1014 42.929 45.0822 42.8753 45.0624 42.8356C45.0552 42.8213 45.0473 42.8077 45.0434 42.801L45.0423 42.7991C45.0378 42.7912 45.036 42.7879 45.0345 42.785C45.0169 42.7497 44.9924 42.7096 44.9548 42.672C44.9171 42.6343 44.877 42.6099 44.8417 42.5922C44.8388 42.5908 44.8355 42.589 44.8276 42.5844L44.8257 42.5834C44.819 42.5794 44.8054 42.5716 44.7911 42.5644C44.7514 42.5446 44.6977 42.5254 44.6287 42.5254H44.6286H44.6285H44.6283H44.6282H44.6281H44.628H44.6279H44.6277H44.6276H44.6275H44.6274H44.6272H44.6271H44.627H44.6269H44.6267H44.6266H44.6265H44.6264H44.6262H44.6261H44.626H44.6258H44.6257H44.6256H44.6255H44.6253H44.6252H44.6251H44.6249H44.6248H44.6247H44.6245H44.6244H44.6243H44.6241H44.624H44.6239H44.6237H44.6236H44.6235H44.6233H44.6232H44.623H44.6229H44.6228H44.6226H44.6225H44.6223H44.6222H44.6221H44.6219H44.6218H44.6216H44.6215H44.6214H44.6212H44.6211H44.6209H44.6208H44.6206H44.6205H44.6203H44.6202H44.62H44.6199H44.6198H44.6196H44.6195H44.6193H44.6192H44.619H44.6189H44.6187H44.6186H44.6184H44.6183H44.6181H44.618H44.6178H44.6176H44.6175H44.6173H44.6172H44.617H44.6169H44.6167H44.6166H44.6164H44.6163H44.6161H44.6159H44.6158H44.6156H44.6155H44.6153H44.6151H44.615H44.6148H44.6147H44.6145H44.6143H44.6142H44.614H44.6139H44.6137H44.6135H44.6134H44.6132H44.613H44.6129H44.6127H44.6125H44.6124H44.6122H44.6121H44.6119H44.6117H44.6116H44.6114H44.6112H44.611H44.6109H44.6107H44.6105H44.6104H44.6102H44.61H44.6099H44.6097H44.6095H44.6093H44.6092H44.609H44.6088H44.6087H44.6085H44.6083H44.6081H44.608H44.6078H44.6076H44.6074H44.6073H44.6071H44.6069H44.6067H44.6066H44.6064H44.6062H44.606H44.6058H44.6057H44.6055H44.6053H44.6051H44.6049H44.6048H44.6046H44.6044H44.6042H44.604H44.6039H44.6037H44.6035H44.6033H44.6031H44.6029H44.6028H44.6026H44.6024H44.6022H44.602H44.6018H44.6016H44.6015H44.6013H44.6011H44.6009H44.6007H44.6005H44.6003H44.6001H44.6H44.5998H44.5996H44.5994H44.5992H44.599H44.5988H44.5986H44.5984H44.5983H44.5981H44.5979H44.5977H44.5975H44.5973H44.5971H44.5969H44.5967H44.5965H44.5963H44.5961H44.5959H44.5957H44.5955H44.5954H44.5952H44.595H44.5948H44.5946H44.5944H44.5942H44.594H44.5938H44.5936H44.5934H44.5932H44.593H44.5928H44.5926H44.5924H44.5922H44.592H44.5918H44.5916H44.5914H44.5912H44.591H44.5908H44.5906H44.5904H44.5902H44.59H44.5898H44.5896H44.5894H44.5892H44.589H44.5888H44.5886H44.5883H44.5881H44.5879H44.5877H44.5875H44.5873H44.5871H44.5869H44.5867H44.5865H44.5863H44.5861H44.5859H44.5857H44.5855H44.5853H44.585H44.5848H44.5846H44.5844H44.5842H44.584H44.5838H44.5836H44.5834H44.5832H44.583H44.5827H44.5825H44.5823H44.5821H44.5819H44.5817H44.5815H44.5813H44.581H44.5808H44.5806H44.5804H44.5802H44.58H44.5798H44.5796H44.5793H44.5791H44.5789H44.5787H44.5785H44.5783H44.5781H44.5778H44.5776H44.5774H44.5772H44.577H44.5768H44.5765H44.5763H44.5761H44.5759H44.5757H44.5755H44.5752H44.575H44.5748H44.5746H44.5744H44.5741H44.5739H44.5737H44.5735H44.5733H44.573H44.5728H44.5726H44.5724H44.5722H44.5719H44.5717H44.5715H44.5713H44.5711H44.5708H44.5706H44.5704H44.5702H44.57H44.5697H44.5695H44.5693H44.5691H44.5688H44.5686H44.5684H44.5682H44.5679H44.5677H44.5675H44.5673H44.5671H44.5668H44.5666H44.5664H44.5662H44.5659H44.5657H44.5655H44.5653H44.565H44.5648H44.5646H44.5644H44.5641H44.5639H44.5637H44.5634H44.5632H44.563H44.5628H44.5625H44.5623H44.5621H44.5619H44.5616H44.5614H44.5612H44.5609H44.5607H44.5605H44.5603H44.56H44.5598H44.5596H44.5593H44.5591H44.5589H44.5587H44.5584H44.5582H44.558H44.5577H44.5575H44.5573H44.5571H44.5568H44.5566H44.5564H44.5561H44.5559H44.5557H44.5554H44.5552H44.555H44.5547H44.5545H44.5543H44.5541H44.5538H44.5536H44.5534H44.5531H44.5529H44.5527H44.5524H44.5522H44.552H44.5517H44.5515H44.5513H44.551H44.5508H44.5506H44.5503H44.5501H44.5499H44.5496H44.5494H44.5492H44.5489H44.5487H44.5485H44.5482H44.548H44.5478H44.5475H44.5473H44.5471H44.5468H44.5466H44.5464H44.5461H44.5459H44.5457H44.5454H44.5452H44.545H44.5447H44.5445H44.5442H44.544H44.5438H44.5435H44.5433H44.5431H44.5428H44.5426H44.5424H44.5421H44.5419H44.5417H44.5414H44.5412H44.541H44.5407H44.5405H44.5402H44.54H44.5398H44.5395H44.5393H44.5391H44.5388H44.5386H44.5384H44.5381H44.5379H44.5376H44.5374H44.5372H44.5369H44.5367H44.5365H44.5362H44.536H44.5358H44.5355H44.5353H44.535H44.5348H44.5346H44.5343H44.5341H44.5339H44.5336H44.5334H44.5331H44.5329H44.5327H44.5324H44.5322H44.532H44.5317H44.5315H44.5312H44.531H44.5308H44.5305H44.5303H44.5301H44.5298H44.5296H44.5294H44.5291H44.5289H44.5286H44.5284H44.5282H44.5279H44.5277H44.5275C44.4585 42.5254 44.4048 42.5446 44.3651 42.5644C44.3508 42.5716 44.3372 42.5794 44.3304 42.5833L44.3285 42.5844C44.3207 42.589 44.3174 42.5908 44.3144 42.5922C44.2495 42.6247 44.2081 42.6698 44.1861 42.6963C44.1773 42.7068 44.1685 42.7183 44.1645 42.7235C44.1639 42.7244 44.1634 42.725 44.163 42.7255L44.1546 42.7339L44.143 42.7498L36.0132 53.9293L31.401 49.3187C31.35 49.2677 31.2909 49.226 31.2203 49.1989C31.1509 49.1722 31.0831 49.1645 31.0218 49.1645C30.9604 49.1645 30.8927 49.1722 30.8232 49.1989C30.7526 49.226 30.6935 49.2677 30.6425 49.3187L30.625 49.3362L30.6113 49.3568C30.6094 49.3596 30.6074 49.3626 30.6053 49.3657C30.5671 49.4224 30.4883 49.5394 30.4883 49.6979C30.4883 49.8564 30.5671 49.9734 30.6053 50.0301C30.6074 50.0332 30.6094 50.0362 30.6113 50.039L30.625 50.0596L30.6425 50.0771L35.9274 55.3601Z",
    fill: "#FAFAFA",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9731 23.4408C57.9123 23.4003 57.8516 23.3598 57.8111 23.2991C57.5681 22.9955 57.6288 22.53 57.9326 22.3073L65.3435 16.5385C65.6472 16.2957 66.1129 16.3564 66.3357 16.66C66.5787 16.9636 66.5179 17.4292 66.2142 17.6518L58.8032 23.4206C58.5603 23.6027 58.216 23.6027 57.9731 23.4408Z",
    fill: "url(#paint1_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4037 11.2373C47.343 11.2171 47.262 11.1968 47.2012 11.1563C46.8772 10.9337 46.776 10.5086 46.9785 10.1645L52.0609 2.27044C52.2836 1.94658 52.7088 1.84537 53.0531 2.04778C53.377 2.27044 53.4783 2.6955 53.2758 3.03961L48.1934 10.9337C48.0112 11.1968 47.6872 11.3183 47.4037 11.2373Z",
    fill: "url(#paint2_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5807 15.9961C19.5402 16.0568 19.4997 16.1176 19.439 16.158C19.1352 16.4212 18.6898 16.3807 18.4265 16.0771L12.2912 8.95217C12.028 8.64855 12.0685 8.20325 12.3722 7.94011C12.676 7.67697 13.1214 7.71745 13.3847 8.02107L19.52 15.146C19.7224 15.3889 19.7427 15.733 19.5807 15.9961Z",
    fill: "url(#paint3_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6521 25.3865C10.6521 25.4674 10.6319 25.5282 10.6116 25.6091C10.4699 25.9735 10.0447 26.1556 9.68018 26.0139L0.95308 22.5325C0.588607 22.3908 0.406371 21.9657 0.54811 21.6014C0.689849 21.237 1.11507 21.0548 1.47955 21.1965L10.2066 24.678C10.5104 24.7995 10.6724 25.0828 10.6521 25.3865Z",
    fill: "url(#paint4_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6819 11.3391C32.6212 11.3795 32.5604 11.3998 32.4794 11.42C32.0947 11.5212 31.71 11.2986 31.6087 10.914L29.1992 1.84592C29.0979 1.46134 29.3207 1.07676 29.7054 0.975549C30.0901 0.874343 30.4748 1.097 30.5761 1.48158L32.9856 10.5496C33.0869 10.8533 32.9451 11.1771 32.6819 11.3391Z",
    fill: "url(#paint5_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7936 17.5527H23.7734V19.84H23.7936V17.5527Z",
    fill: "#0017BF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8131 17.5527H23.793V19.84H23.8131V17.5527Z",
    fill: "#001AC0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8131 17.5527H23.793V19.84H23.8131V17.5527Z",
    fill: "#011DC0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8341 17.5527H23.814V19.84H23.8341V17.5527Z",
    fill: "#0120C1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8341 17.5527H23.814V19.84H23.8341V17.5527Z",
    fill: "#0223C1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8566 17.5527H23.8364V19.84H23.8566V17.5527Z",
    fill: "#0226C2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8566 17.5527H23.8364V19.84H23.8566V17.5527Z",
    fill: "#0229C2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8751 17.5527H23.855V19.84H23.8751V17.5527Z",
    fill: "#032CC3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8751 17.5527H23.855V19.84H23.8751V17.5527Z",
    fill: "#032FC4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8961 17.5527H23.876V19.84H23.8961V17.5527Z",
    fill: "#0332C4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8961 17.5527H23.876V19.84H23.8961V17.5527Z",
    fill: "#0435C5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9156 17.5527H23.8955V19.84H23.9156V17.5527Z",
    fill: "#0437C5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9366 17.5527H23.9165V19.84H23.9366V17.5527Z",
    fill: "#043AC6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9366 17.5527H23.9165V19.84H23.9366V17.5527Z",
    fill: "#053DC6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9557 17.5527H23.9355V19.84H23.9557V17.5527Z",
    fill: "#0540C7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9557 17.5527H23.9355V19.84H23.9557V17.5527Z",
    fill: "#0542C7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9757 17.5527H23.9556V19.84H23.9757V17.5527Z",
    fill: "#0645C8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9757 17.5527H23.9556V19.84H23.9757V17.5527Z",
    fill: "#0648C8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9962 17.5527H23.9761V19.84H23.9962V17.5527Z",
    fill: "#064AC9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9962 17.5527H23.9761V19.84H23.9962V17.5527Z",
    fill: "#074DC9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0167 17.5527H23.9966V19.84H24.0167V17.5527Z",
    fill: "#074FCA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0167 17.5527H23.9966V19.84H24.0167V17.5527Z",
    fill: "#0752CA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0367 17.5527H24.0166V19.84H24.0367V17.5527Z",
    fill: "#0854CB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0568 17.5527H24.0366V19.84H24.0568V17.5527Z",
    fill: "#0857CB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0568 17.5527H24.0366V19.84H24.0568V17.5527Z",
    fill: "#0859CB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0772 17.5527H24.0571V19.84H24.0772V17.5527Z",
    fill: "#095CCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0772 17.5527H24.0571V19.84H24.0772V17.5527Z",
    fill: "#095ECC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0963 17.5527H24.0762V19.84H24.0963V17.5527Z",
    fill: "#0960CD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0963 17.5527H24.0762V19.84H24.0963V17.5527Z",
    fill: "#0963CD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1183 17.5527H24.0981V19.84H24.1183V17.5527Z",
    fill: "#0A65CE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1183 17.5527H24.0981V19.84H24.1183V17.5527Z",
    fill: "#0A67CE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1378 17.5527H24.1177V19.84H24.1378V17.5527Z",
    fill: "#0A69CF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1378 17.5527H24.1177V19.84H24.1378V17.5527Z",
    fill: "#0B6BCF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1578 17.5527H24.1377V19.84H24.1578V17.5527Z",
    fill: "#0B6ECF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1783 17.5527H24.1582V19.84H24.1783V17.5527Z",
    fill: "#0B70D0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1783 17.5527H24.1582V19.84H24.1783V17.5527Z",
    fill: "#0B72D0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1979 17.5527H24.1777V19.84H24.1979V17.5527Z",
    fill: "#0C74D1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1979 17.5527H24.1777V19.84H24.1979V17.5527Z",
    fill: "#0C76D1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2194 17.5527H24.1992V19.84H24.2194V17.5527Z",
    fill: "#0C78D1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2194 17.5527H24.1992V19.84H24.2194V17.5527Z",
    fill: "#0C7AD2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2389 17.5527H24.2188V19.84H24.2389V17.5527Z",
    fill: "#0D7CD2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2389 17.5527H24.2188V19.84H24.2389V17.5527Z",
    fill: "#0D7ED2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2599 17.5527H24.2397V19.84H24.2599V17.5527Z",
    fill: "#0D80D3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2599 17.5527H24.2397V19.84H24.2599V17.5527Z",
    fill: "#0D82D3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2789 17.5527H24.2588V19.84H24.2789V17.5527Z",
    fill: "#0E84D4"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2989 17.5527H24.2788V19.84H24.2989V17.5527Z",
    fill: "#0E86D4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2989 17.5527H24.2788V19.84H24.2989V17.5527Z",
    fill: "#0E88D4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3204 17.5527H24.3003V19.84H24.3204V17.5527Z",
    fill: "#0E89D5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3204 17.5527H24.3003V19.84H24.3204V17.5527Z",
    fill: "#0F8BD5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3405 17.5527H24.3203V19.84H24.3405V17.5527Z",
    fill: "#0F8DD5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3405 17.5527H24.3203V19.84H24.3405V17.5527Z",
    fill: "#0F8FD6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M24.361 17.5527H24.3408V19.84H24.361V17.5527Z",
    fill: "#0F90D6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24.361 17.5527H24.3408V19.84H24.361V17.5527Z",
    fill: "#0F92D6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.38 17.5527H24.3599V19.84H24.38V17.5527Z",
    fill: "#1094D7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M24.38 17.5527H24.3599V19.84H24.38V17.5527Z",
    fill: "#1095D7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M24.401 17.5527H24.3809V19.84H24.401V17.5527Z",
    fill: "#1097D7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4215 17.5527H24.4014V19.84H24.4215V17.5527Z",
    fill: "#1099D7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4215 17.5527H24.4014V19.84H24.4215V17.5527Z",
    fill: "#109AD8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4415 17.5527H24.4214V19.84H24.4415V17.5527Z",
    fill: "#119CD8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4415 17.5527H24.4214V19.84H24.4415V17.5527Z",
    fill: "#119DD8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M24.463 17.5527H24.4429V19.84H24.463V17.5527Z",
    fill: "#119FD9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M24.463 17.5527H24.4429V19.84H24.463V17.5527Z",
    fill: "#11A0D9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M24.482 17.5527H24.4619V19.84H24.482V17.5527Z",
    fill: "#11A2D9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M24.482 17.5527H24.4619V19.84H24.482V17.5527Z",
    fill: "#12A3D9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5021 17.5527H24.4819V19.84H24.5021V17.5527Z",
    fill: "#12A5DA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5021 17.5527H24.4819V19.84H24.5021V17.5527Z",
    fill: "#12A6DA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5226 17.5527H24.5024V19.84H24.5226V17.5527Z",
    fill: "#12A8DA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5426 17.5527H24.5225V19.84H24.5426V17.5527Z",
    fill: "#12A9DB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5426 17.5527H24.5225V19.84H24.5426V17.5527Z",
    fill: "#13AADB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5626 17.5527H24.5425V19.84H24.5626V17.5527Z",
    fill: "#13ACDB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5626 17.5527H24.5425V19.84H24.5626V17.5527Z",
    fill: "#13ADDB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5821 17.5527H24.562V19.84H24.5821V17.5527Z",
    fill: "#13AEDC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5821 17.5527H24.562V19.84H24.5821V17.5527Z",
    fill: "#13B0DC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6036 17.5527H24.5835V19.84H24.6036V17.5527Z",
    fill: "#13B1DC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6036 17.5527H24.5835V19.84H24.6036V17.5527Z",
    fill: "#13B2DC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6246 17.5527H24.6045V19.84H24.6246V17.5527Z",
    fill: "#14B3DC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6246 17.5527H24.6045V19.84H24.6246V17.5527Z",
    fill: "#14B4DD"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6446 17.5527H24.6245V19.84H24.6446V17.5527Z",
    fill: "#14B6DD"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6642 17.5527H24.644V19.84H24.6642V17.5527Z",
    fill: "#14B7DD"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6642 17.5527H24.644V19.84H24.6642V17.5527Z",
    fill: "#14B8DD"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6842 17.5527H24.6641V19.84H24.6842V17.5527Z",
    fill: "#14B9DE"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6842 17.5527H24.6641V19.84H24.6842V17.5527Z",
    fill: "#14BADE"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7042 17.5527H24.6841V19.84H24.7042V17.5527Z",
    fill: "#15BBDE"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7042 17.5527H24.6841V19.84H24.7042V17.5527Z",
    fill: "#15BCDE"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7247 17.5527H24.7046V19.84H24.7247V17.5527Z",
    fill: "#15BDDE"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7247 17.5527H24.7046V19.84H24.7247V17.5527Z",
    fill: "#15BEDF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7457 17.5527H24.7256V19.84H24.7457V17.5527Z",
    fill: "#15BFDF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7457 17.5527H24.7256V19.84H24.7457V17.5527Z",
    fill: "#15C0DF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7653 17.5527H24.7451V19.84H24.7653V17.5527Z",
    fill: "#15C1DF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7853 17.5527H24.7651V19.84H24.7853V17.5527Z",
    fill: "#16C2DF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7853 17.5527H24.7651V19.84H24.7853V17.5527Z",
    fill: "#16C3DF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8063 17.5527H24.7861V19.84H24.8063V17.5527Z",
    fill: "#16C4E0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8063 17.5527H24.7861V19.84H24.8063V17.5527Z",
    fill: "#16C5E0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8268 17.5527H24.8066V19.84H24.8268V17.5527Z",
    fill: "#16C6E0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8268 17.5527H24.8066V19.84H24.8268V17.5527Z",
    fill: "#16C7E0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8458 17.5527H24.8257V19.84H24.8458V17.5527Z",
    fill: "#16C8E0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8458 17.5527H24.8257V19.84H24.8458V17.5527Z",
    fill: "#16C9E0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8673 17.5527H24.8472V19.84H24.8673V17.5527Z",
    fill: "#16C9E1"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8673 17.5527H24.8472V19.84H24.8673V17.5527Z",
    fill: "#17CAE1"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8873 17.5527H24.8672V19.84H24.8873V17.5527Z",
    fill: "#17CBE1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9074 17.5527H24.8872V19.84H24.9074V17.5527Z",
    fill: "#17CCE1"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9074 17.5527H24.8872V19.84H24.9074V17.5527Z",
    fill: "#17CCE1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9278 17.5527H24.9077V19.84H24.9278V17.5527Z",
    fill: "#17CDE1"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9278 17.5527H24.9077V19.84H24.9278V17.5527Z",
    fill: "#17CEE1"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9469 17.5527H24.9268V19.84H24.9469V17.5527Z",
    fill: "#17CFE2"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9469 17.5527H24.9268V19.84H24.9469V17.5527Z",
    fill: "#17CFE2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9679 17.5527H24.9478V19.84H24.9679V17.5527Z",
    fill: "#17D0E2"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9679 17.5527H24.9478V19.84H24.9679V17.5527Z",
    fill: "#17D1E2"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9874 17.5527H24.9673V19.84H24.9874V17.5527Z",
    fill: "#17D1E2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9874 17.5527H24.9673V19.84H24.9874V17.5527Z",
    fill: "#17D2E2"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0094 17.5527H24.9893V19.84H25.0094V17.5527Z",
    fill: "#18D3E2"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0299 17.5527H25.0098V19.84H25.0299V17.5527Z",
    fill: "#18D3E2"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0299 17.5527H25.0098V19.84H25.0299V17.5527Z",
    fill: "#18D4E3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0489 17.5527H25.0288V19.84H25.0489V17.5527Z",
    fill: "#18D4E3"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0489 17.5527H25.0288V19.84H25.0489V17.5527Z",
    fill: "#18D5E3"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M25.069 17.5527H25.0488V19.84H25.069V17.5527Z",
    fill: "#18D6E3"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M25.069 17.5527H25.0488V19.84H25.069V17.5527Z",
    fill: "#18D6E3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0894 17.5527H25.0693V19.84H25.0894V17.5527Z",
    fill: "#18D7E3"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0894 17.5527H25.0693V19.84H25.0894V17.5527Z",
    fill: "#18D7E3"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1095 17.5527H25.0894V19.84H25.1095V17.5527Z",
    fill: "#18D8E3"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1095 17.5527H25.0894V19.84H25.1095V17.5527Z",
    fill: "#18D8E3"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1295 17.5527H25.1094V19.84H25.1295V17.5527Z",
    fill: "#18D9E4"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M25.15 17.5527H25.1299V19.84H25.15V17.5527Z",
    fill: "#18D9E4"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M25.15 17.5527H25.1299V19.84H25.15V17.5527Z",
    fill: "#18DAE4"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M25.171 17.5527H25.1509V19.84H25.171V17.5527Z",
    fill: "#19DAE4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M25.171 17.5527H25.1509V19.84H25.171V17.5527Z",
    fill: "#19DBE4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1905 17.5527H25.1704V19.84H25.1905V17.5527Z",
    fill: "#19DBE4"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1905 17.5527H25.1704V19.84H25.1905V17.5527Z",
    fill: "#19DBE4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2116 17.5527H25.1914V19.84H25.2116V17.5527Z",
    fill: "#19DCE4"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2116 17.5527H25.1914V19.84H25.2116V17.5527Z",
    fill: "#19DCE4"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2315 17.5527H25.2114V19.84H25.2315V17.5527Z",
    fill: "#19DDE4"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2315 17.5527H25.2114V19.84H25.2315V17.5527Z",
    fill: "#19DDE4"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2511 17.5527H25.231V19.84H25.2511V17.5527Z",
    fill: "#19DDE4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2711 17.5527H25.251V19.84H25.2711V17.5527Z",
    fill: "#19DEE4"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2711 17.5527H25.251V19.84H25.2711V17.5527Z",
    fill: "#19DEE5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2926 17.5527H25.2725V19.84H25.2926V17.5527Z",
    fill: "#19DEE5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2926 17.5527H25.2725V19.84H25.2926V17.5527Z",
    fill: "#19DFE5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3116 17.5527H25.2915V19.84H25.3116V17.5527Z",
    fill: "#19DFE5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3116 17.5527H25.2915V19.84H25.3116V17.5527Z",
    fill: "#19DFE5"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3326 17.5527H25.3125V19.84H25.3326V17.5527Z",
    fill: "#19E0E5"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3326 17.5527H25.3125V19.84H25.3326V17.5527Z",
    fill: "#19E0E5"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3522 17.5527H25.332V19.84H25.3522V17.5527Z",
    fill: "#19E0E5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3522 17.5527H25.332V19.84H25.3522V17.5527Z",
    fill: "#19E1E5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3732 17.5527H25.353V19.84H25.3732V17.5527Z",
    fill: "#19E1E5"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3932 17.5527H25.373V19.84H25.3932V17.5527Z",
    fill: "#19E1E5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3932 17.5527H25.373V19.84H25.3932V17.5527Z",
    fill: "#19E1E5"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4137 17.5527H25.3936V19.84H25.4137V17.5527Z",
    fill: "#19E2E5"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4137 17.5527H25.3936V19.84H25.4137V17.5527Z",
    fill: "#19E2E5"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4347 17.5527H25.4146V19.84H25.4347V17.5527Z",
    fill: "#19E2E5"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4347 17.5527H25.4146V19.84H25.4347V17.5527Z",
    fill: "#1AE2E5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4537 17.5527H25.4336V19.84H25.4537V17.5527Z",
    fill: "#1AE2E5"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4537 17.5527H25.4336V19.84H25.4537V17.5527Z",
    fill: "#1AE3E5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4742 17.5527H25.4541V19.84H25.4742V17.5527Z",
    fill: "#1AE3E5"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4742 17.5527H25.4541V19.84H25.4742V17.5527Z",
    fill: "#1AE3E5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4947 17.5527H25.4746V19.84H25.4947V17.5527Z",
    fill: "#1AE3E5"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5138 17.5527H25.4937V19.84H25.5138V17.5527Z",
    fill: "#1AE3E5"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5138 17.5527H25.4937V19.84H25.5138V17.5527Z",
    fill: "#1AE3E6"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5348 17.5527H25.5146V19.84H25.5348V17.5527Z",
    fill: "#1AE4E6"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5348 17.5527H25.5146V19.84H25.5348V17.5527Z",
    fill: "#1AE4E6"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5548 17.5527H25.5347V19.84H25.5548V17.5527Z",
    fill: "#1AE4E6"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5548 17.5527H25.5347V19.84H25.5548V17.5527Z",
    fill: "#1AE4E6"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5763 17.5527H25.5562V19.84H25.5763V17.5527Z",
    fill: "#1AE4E6"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5763 17.5527H25.5562V19.84H25.5763V17.5527Z",
    fill: "#1AE4E6"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5953 17.5527H25.5752V19.84H25.5953V17.5527Z",
    fill: "#1AE4E6"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5953 17.5527H25.5752V19.84H25.5953V17.5527Z",
    fill: "#1AE5E6"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6159 17.5527H25.5957V19.84H25.6159V17.5527Z",
    fill: "#1AE5E6"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6368 17.5527H25.6167V19.84H25.6368V17.5527Z",
    fill: "#1AE5E6"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6368 17.5527H25.6167V19.84H25.6368V17.5527Z",
    fill: "#1AE5E6"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6564 17.5527H25.6362V19.84H25.6564V17.5527Z",
    fill: "#1AE5E6"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6564 17.5527H25.6362V19.84H25.6564V17.5527Z",
    fill: "#1AE5E6"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6764 17.5527H25.6562V19.84H25.6764V17.5527Z",
    fill: "#1AE5E6"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6764 17.5527H25.6562V19.84H25.6764V17.5527Z",
    fill: "#1AE5E6"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6964 17.5527H25.6763V19.84H25.6964V17.5527Z",
    fill: "#1AE5E6"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6964 17.5527H25.6763V19.84H25.6964V17.5527Z",
    fill: "#1AE5E6"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7169 17.5527H25.6968V19.84H25.7169V17.5527Z",
    fill: "#1AE5E6"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7169 17.5527H25.6968V19.84H25.7169V17.5527Z",
    fill: "#1AE5E6"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7369 17.5527H25.7168V19.84H25.7369V17.5527Z",
    fill: "#1AE5E6"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7579 17.5527H25.7378V19.84H25.7579V17.5527Z",
    fill: "#1AE6E6"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7579 17.5527H25.7378V19.84H25.7579V17.5527Z",
    fill: "#1AE6E6"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7784 17.5527H25.7583V19.84H25.7784V17.5527Z",
    fill: "#1AE6E6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7784 17.5527H25.7583V19.84H25.7784V17.5527Z",
    fill: "#1AE6E6"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7975 17.5527H25.7773V19.84H25.7975V17.5527Z",
    fill: "#1AE6E6"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7975 17.5527H25.7773V19.84H25.7975V17.5527Z",
    fill: "#1AE6E6"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8185 17.5527H25.7983V19.84H25.8185V17.5527Z",
    fill: "#1AE6E6"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8185 17.5527H25.7983V19.84H25.8185V17.5527Z",
    fill: "#1AE6E6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M25.839 17.5527H25.8188V19.84H25.839V17.5527Z",
    fill: "#1AE6E6"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M25.839 17.5527H25.8188V19.84H25.839V17.5527Z",
    fill: "#1AE6E6"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8595 17.5527H25.8394V19.84H25.8595V17.5527Z",
    fill: "#1AE6E6"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8785 17.5527H25.8584V19.84H25.8785V17.5527Z",
    fill: "#1AE6E6"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8785 17.5527H25.8584V19.84H25.8785V17.5527Z",
    fill: "#1AE6E6"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8986 17.5527H25.8784V19.84H25.8986V17.5527Z",
    fill: "#1AE6E6"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8986 17.5527H25.8784V19.84H25.8986V17.5527Z",
    fill: "#1AE6E6"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9186 17.5527H25.8984V19.84H25.9186V17.5527Z",
    fill: "#1AE6E6"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9186 17.5527H25.8984V19.84H25.9186V17.5527Z",
    fill: "#1AE6E6"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9401 17.5527H25.9199V19.84H25.9401V17.5527Z",
    fill: "#1AE6E6"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9401 17.5527H25.9199V19.84H25.9401V17.5527Z",
    fill: "#1AE6E6"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M25.961 17.5527H25.9409V19.84H25.961V17.5527Z",
    fill: "#1AE6E6"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M25.961 17.5527H25.9409V19.84H25.961V17.5527Z",
    fill: "#1AE6E6"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9806 17.5527H25.9604V19.84H25.9806V17.5527Z",
    fill: "#1AE6E6"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0006 17.5527H25.9805V19.84H26.0006V17.5527Z",
    fill: "#1AE6E6"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0006 17.5527H25.9805V19.84H26.0006V17.5527Z",
    fill: "#1AE6E6"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0206 17.5527H26.0005V19.84H26.0206V17.5527Z",
    fill: "#1AE6E6"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0206 17.5527H26.0005V19.84H26.0206V17.5527Z",
    fill: "#1AE6E6"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0421 17.5527H26.022V19.84H26.0421V17.5527Z",
    fill: "#1AE6E6"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0421 17.5527H26.022V19.84H26.0421V17.5527Z",
    fill: "#1AE6E6"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0611 17.5527H26.041V19.84H26.0611V17.5527Z",
    fill: "#1AE6E6"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0611 17.5527H26.041V19.84H26.0611V17.5527Z",
    fill: "#1AE6E6"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M67.733 33.7461H67.7129V36.0333H67.733V33.7461Z",
    fill: "#0017BF"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7525 33.7461H67.7324V36.0333H67.7525V33.7461Z",
    fill: "#001AC0"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7525 33.7461H67.7324V36.0333H67.7525V33.7461Z",
    fill: "#011DC0"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7731 33.7461H67.7529V36.0333H67.7731V33.7461Z",
    fill: "#0120C1"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7731 33.7461H67.7529V36.0333H67.7731V33.7461Z",
    fill: "#0223C1"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7941 33.7461H67.7739V36.0333H67.7941V33.7461Z",
    fill: "#0226C2"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7941 33.7461H67.7739V36.0333H67.7941V33.7461Z",
    fill: "#0229C2"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M67.814 33.7461H67.7939V36.0333H67.814V33.7461Z",
    fill: "#032CC3"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M67.814 33.7461H67.7939V36.0333H67.814V33.7461Z",
    fill: "#032FC4"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8331 33.7461H67.813V36.0333H67.8331V33.7461Z",
    fill: "#0332C4"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8331 33.7461H67.813V36.0333H67.8331V33.7461Z",
    fill: "#0435C5"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8547 33.7461H67.8345V36.0333H67.8547V33.7461Z",
    fill: "#0437C5"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 33.7461H67.8545V36.0333H67.8746V33.7461Z",
    fill: "#043AC6"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8746 33.7461H67.8545V36.0333H67.8746V33.7461Z",
    fill: "#053DC6"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8947 33.7461H67.8745V36.0333H67.8947V33.7461Z",
    fill: "#0540C7"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8947 33.7461H67.8745V36.0333H67.8947V33.7461Z",
    fill: "#0542C7"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9143 33.7461H67.894V36.0333H67.9143V33.7461Z",
    fill: "#0645C8"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9143 33.7461H67.894V36.0333H67.9143V33.7461Z",
    fill: "#0648C8"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9342 33.7461H67.9141V36.0333H67.9342V33.7461Z",
    fill: "#064AC9"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9342 33.7461H67.9141V36.0333H67.9342V33.7461Z",
    fill: "#074DC9"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9557 33.7461H67.9355V36.0333H67.9557V33.7461Z",
    fill: "#074FCA"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9557 33.7461H67.9355V36.0333H67.9557V33.7461Z",
    fill: "#0752CA"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9747 33.7461H67.9546V36.0333H67.9747V33.7461Z",
    fill: "#0854CB"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9962 33.7461H67.9761V36.0333H67.9962V33.7461Z",
    fill: "#0857CB"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9962 33.7461H67.9761V36.0333H67.9962V33.7461Z",
    fill: "#0859CB"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0162 33.7461H67.9961V36.0333H68.0162V33.7461Z",
    fill: "#095CCC"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0162 33.7461H67.9961V36.0333H68.0162V33.7461Z",
    fill: "#095ECC"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0353 33.7461H68.0151V36.0333H68.0353V33.7461Z",
    fill: "#0960CD"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0353 33.7461H68.0151V36.0333H68.0353V33.7461Z",
    fill: "#0963CD"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0568 33.7461H68.0366V36.0333H68.0568V33.7461Z",
    fill: "#0A65CE"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0568 33.7461H68.0366V36.0333H68.0568V33.7461Z",
    fill: "#0A67CE"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0758 33.7461H68.0557V36.0333H68.0758V33.7461Z",
    fill: "#0A69CF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0758 33.7461H68.0557V36.0333H68.0758V33.7461Z",
    fill: "#0B6BCF"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0968 33.7461H68.0767V36.0333H68.0968V33.7461Z",
    fill: "#0B6ECF"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1158 33.7461H68.0957V36.0333H68.1158V33.7461Z",
    fill: "#0B70D0"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1158 33.7461H68.0957V36.0333H68.1158V33.7461Z",
    fill: "#0B72D0"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1373 33.7461H68.1172V36.0333H68.1373V33.7461Z",
    fill: "#0C74D1"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1373 33.7461H68.1172V36.0333H68.1373V33.7461Z",
    fill: "#0C76D1"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1588 33.7461H68.1387V36.0333H68.1588V33.7461Z",
    fill: "#0C78D1"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1588 33.7461H68.1387V36.0333H68.1588V33.7461Z",
    fill: "#0C7AD2"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1779 33.7461H68.1577V36.0333H68.1779V33.7461Z",
    fill: "#0D7CD2"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1779 33.7461H68.1577V36.0333H68.1779V33.7461Z",
    fill: "#0D7ED2"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1988 33.7461H68.1787V36.0333H68.1988V33.7461Z",
    fill: "#0D80D3"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1988 33.7461H68.1787V36.0333H68.1988V33.7461Z",
    fill: "#0D82D3"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2179 33.7461H68.1978V36.0333H68.2179V33.7461Z",
    fill: "#0E84D4"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2384 33.7461H68.2183V36.0333H68.2384V33.7461Z",
    fill: "#0E86D4"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2384 33.7461H68.2183V36.0333H68.2384V33.7461Z",
    fill: "#0E88D4"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2585 33.7461H68.2383V36.0333H68.2585V33.7461Z",
    fill: "#0E89D5"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2585 33.7461H68.2383V36.0333H68.2585V33.7461Z",
    fill: "#0F8BD5"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2789 33.7461H68.2588V36.0333H68.2789V33.7461Z",
    fill: "#0F8DD5"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2789 33.7461H68.2588V36.0333H68.2789V33.7461Z",
    fill: "#0F8FD6"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2989 33.7461H68.2788V36.0333H68.2989V33.7461Z",
    fill: "#0F90D6"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2989 33.7461H68.2788V36.0333H68.2989V33.7461Z",
    fill: "#0F92D6"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M68.319 33.7461H68.2988V36.0333H68.319V33.7461Z",
    fill: "#1094D7"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M68.319 33.7461H68.2988V36.0333H68.319V33.7461Z",
    fill: "#1095D7"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3405 33.7461H68.3203V36.0333H68.3405V33.7461Z",
    fill: "#1097D7"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3604 33.7461H68.3403V36.0333H68.3604V33.7461Z",
    fill: "#1099D7"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3604 33.7461H68.3403V36.0333H68.3604V33.7461Z",
    fill: "#109AD8"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M68.38 33.7461H68.3599V36.0333H68.38V33.7461Z",
    fill: "#119CD8"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M68.38 33.7461H68.3599V36.0333H68.38V33.7461Z",
    fill: "#119DD8"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4001 33.7461H68.3799V36.0333H68.4001V33.7461Z",
    fill: "#119FD9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4001 33.7461H68.3799V36.0333H68.4001V33.7461Z",
    fill: "#11A0D9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M68.421 33.7461H68.4009V36.0333H68.421V33.7461Z",
    fill: "#11A2D9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M68.421 33.7461H68.4009V36.0333H68.421V33.7461Z",
    fill: "#12A3D9"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4405 33.7461H68.4204V36.0333H68.4405V33.7461Z",
    fill: "#12A5DA"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4405 33.7461H68.4204V36.0333H68.4405V33.7461Z",
    fill: "#12A6DA"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4615 33.7461H68.4414V36.0333H68.4615V33.7461Z",
    fill: "#12A8DA"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4816 33.7461H68.4614V36.0333H68.4816V33.7461Z",
    fill: "#12A9DB"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4816 33.7461H68.4614V36.0333H68.4816V33.7461Z",
    fill: "#13AADB"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5011 33.7461H68.481V36.0333H68.5011V33.7461Z",
    fill: "#13ACDB"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5011 33.7461H68.481V36.0333H68.5011V33.7461Z",
    fill: "#13ADDB"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5221 33.7461H68.502V36.0333H68.5221V33.7461Z",
    fill: "#13AEDC"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5221 33.7461H68.502V36.0333H68.5221V33.7461Z",
    fill: "#13B0DC"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5426 33.7461H68.5225V36.0333H68.5426V33.7461Z",
    fill: "#13B1DC"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5426 33.7461H68.5225V36.0333H68.5426V33.7461Z",
    fill: "#13B2DC"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5636 33.7461H68.5435V36.0333H68.5636V33.7461Z",
    fill: "#14B3DC"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5636 33.7461H68.5435V36.0333H68.5636V33.7461Z",
    fill: "#14B4DD"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5826 33.7461H68.5625V36.0333H68.5826V33.7461Z",
    fill: "#14B6DD"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6021 33.7461H68.582V36.0333H68.6021V33.7461Z",
    fill: "#14B7DD"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6021 33.7461H68.582V36.0333H68.6021V33.7461Z",
    fill: "#14B8DD"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6241 33.7461H68.604V36.0333H68.6241V33.7461Z",
    fill: "#14B9DE"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6241 33.7461H68.604V36.0333H68.6241V33.7461Z",
    fill: "#14BADE"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6432 33.7461H68.623V36.0333H68.6432V33.7461Z",
    fill: "#15BBDE"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6432 33.7461H68.623V36.0333H68.6432V33.7461Z",
    fill: "#15BCDE"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6637 33.7461H68.6436V36.0333H68.6637V33.7461Z",
    fill: "#15BDDE"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6637 33.7461H68.6436V36.0333H68.6637V33.7461Z",
    fill: "#15BEDF"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6837 33.7461H68.6636V36.0333H68.6837V33.7461Z",
    fill: "#15BFDF"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6837 33.7461H68.6636V36.0333H68.6837V33.7461Z",
    fill: "#15C0DF"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7043 33.7461H68.6841V36.0333H68.7043V33.7461Z",
    fill: "#15C1DF"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7242 33.7461H68.7041V36.0333H68.7242V33.7461Z",
    fill: "#16C2DF"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7242 33.7461H68.7041V36.0333H68.7242V33.7461Z",
    fill: "#16C3DF"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7447 33.7461H68.7246V36.0333H68.7447V33.7461Z",
    fill: "#16C4E0"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7447 33.7461H68.7246V36.0333H68.7447V33.7461Z",
    fill: "#16C5E0"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7657 33.7461H68.7456V36.0333H68.7657V33.7461Z",
    fill: "#16C6E0"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7657 33.7461H68.7456V36.0333H68.7657V33.7461Z",
    fill: "#16C7E0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7848 33.7461H68.7646V36.0333H68.7848V33.7461Z",
    fill: "#16C8E0"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7848 33.7461H68.7646V36.0333H68.7848V33.7461Z",
    fill: "#16C9E0"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8054 33.7461H68.7852V36.0333H68.8054V33.7461Z",
    fill: "#16C9E1"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8054 33.7461H68.7852V36.0333H68.8054V33.7461Z",
    fill: "#17CAE1"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8263 33.7461H68.8062V36.0333H68.8263V33.7461Z",
    fill: "#17CBE1"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8464 33.7461H68.8262V36.0333H68.8464V33.7461Z",
    fill: "#17CCE1"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8464 33.7461H68.8262V36.0333H68.8464V33.7461Z",
    fill: "#17CCE1"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8658 33.7461H68.8457V36.0333H68.8658V33.7461Z",
    fill: "#17CDE1"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8658 33.7461H68.8457V36.0333H68.8658V33.7461Z",
    fill: "#17CEE1"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8859 33.7461H68.8657V36.0333H68.8859V33.7461Z",
    fill: "#17CFE2"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8859 33.7461H68.8657V36.0333H68.8859V33.7461Z",
    fill: "#17CFE2"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9073 33.7461H68.8872V36.0333H68.9073V33.7461Z",
    fill: "#17D0E2"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9073 33.7461H68.8872V36.0333H68.9073V33.7461Z",
    fill: "#17D1E2"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9264 33.7461H68.9062V36.0333H68.9264V33.7461Z",
    fill: "#17D1E2"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9264 33.7461H68.9062V36.0333H68.9264V33.7461Z",
    fill: "#17D2E2"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9479 33.7461H68.9277V36.0333H68.9479V33.7461Z",
    fill: "#18D3E2"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9679 33.7461H68.9478V36.0333H68.9679V33.7461Z",
    fill: "#18D3E2"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9679 33.7461H68.9478V36.0333H68.9679V33.7461Z",
    fill: "#18D4E3"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9879 33.7461H68.9678V36.0333H68.9879V33.7461Z",
    fill: "#18D4E3"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9879 33.7461H68.9678V36.0333H68.9879V33.7461Z",
    fill: "#18D5E3"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0079 33.7461H68.9878V36.0333H69.0079V33.7461Z",
    fill: "#18D6E3"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0079 33.7461H68.9878V36.0333H69.0079V33.7461Z",
    fill: "#18D6E3"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0284 33.7461H69.0083V36.0333H69.0284V33.7461Z",
    fill: "#18D7E3"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0284 33.7461H69.0083V36.0333H69.0284V33.7461Z",
    fill: "#18D7E3"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0474 33.7461H69.0273V36.0333H69.0474V33.7461Z",
    fill: "#18D8E3"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0474 33.7461H69.0273V36.0333H69.0474V33.7461Z",
    fill: "#18D8E3"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0684 33.7461H69.0483V36.0333H69.0684V33.7461Z",
    fill: "#18D9E4"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0891 33.7461H69.0688V36.0333H69.0891V33.7461Z",
    fill: "#18D9E4"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0891 33.7461H69.0688V36.0333H69.0891V33.7461Z",
    fill: "#18DAE4"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1095 33.7461H69.0894V36.0333H69.1095V33.7461Z",
    fill: "#19DAE4"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1095 33.7461H69.0894V36.0333H69.1095V33.7461Z",
    fill: "#19DBE4"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1294 33.7461H69.1094V36.0333H69.1294V33.7461Z",
    fill: "#19DBE4"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1294 33.7461H69.1094V36.0333H69.1294V33.7461Z",
    fill: "#19DBE4"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1495 33.7461H69.1294V36.0333H69.1495V33.7461Z",
    fill: "#19DCE4"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1495 33.7461H69.1294V36.0333H69.1495V33.7461Z",
    fill: "#19DCE4"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1701 33.7461H69.1499V36.0333H69.1701V33.7461Z",
    fill: "#19DDE4"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1701 33.7461H69.1499V36.0333H69.1701V33.7461Z",
    fill: "#19DDE4"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M69.19 33.7461H69.1699V36.0333H69.19V33.7461Z",
    fill: "#19DDE4"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2101 33.7461H69.1899V36.0333H69.2101V33.7461Z",
    fill: "#19DEE4"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2101 33.7461H69.1899V36.0333H69.2101V33.7461Z",
    fill: "#19DEE5"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2307 33.7461H69.2104V36.0333H69.2307V33.7461Z",
    fill: "#19DEE5"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2307 33.7461H69.2104V36.0333H69.2307V33.7461Z",
    fill: "#19DFE5"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2507 33.7461H69.2305V36.0333H69.2507V33.7461Z",
    fill: "#19DFE5"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2507 33.7461H69.2305V36.0333H69.2507V33.7461Z",
    fill: "#19DFE5"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2711 33.7461H69.251V36.0333H69.2711V33.7461Z",
    fill: "#19E0E5"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2711 33.7461H69.251V36.0333H69.2711V33.7461Z",
    fill: "#19E0E5"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2911 33.7461H69.271V36.0333H69.2911V33.7461Z",
    fill: "#19E0E5"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2911 33.7461H69.271V36.0333H69.2911V33.7461Z",
    fill: "#19E1E5"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3121 33.7461H69.292V36.0333H69.3121V33.7461Z",
    fill: "#19E1E5"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3312 33.7461H69.311V36.0333H69.3312V33.7461Z",
    fill: "#19E1E5"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3312 33.7461H69.311V36.0333H69.3312V33.7461Z",
    fill: "#19E1E5"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3517 33.7461H69.3315V36.0333H69.3517V33.7461Z",
    fill: "#19E2E5"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3517 33.7461H69.3315V36.0333H69.3517V33.7461Z",
    fill: "#19E2E5"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3732 33.7461H69.353V36.0333H69.3732V33.7461Z",
    fill: "#19E2E5"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3732 33.7461H69.353V36.0333H69.3732V33.7461Z",
    fill: "#1AE2E5"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3932 33.7461H69.373V36.0333H69.3932V33.7461Z",
    fill: "#1AE2E5"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3932 33.7461H69.373V36.0333H69.3932V33.7461Z",
    fill: "#1AE3E5"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4132 33.7461H69.3931V36.0333H69.4132V33.7461Z",
    fill: "#1AE3E5"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4132 33.7461H69.3931V36.0333H69.4132V33.7461Z",
    fill: "#1AE3E5"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4322 33.7461H69.4121V36.0333H69.4322V33.7461Z",
    fill: "#1AE3E5"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4527 33.7461H69.4326V36.0333H69.4527V33.7461Z",
    fill: "#1AE3E5"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4527 33.7461H69.4326V36.0333H69.4527V33.7461Z",
    fill: "#1AE3E6"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4737 33.7461H69.4536V36.0333H69.4737V33.7461Z",
    fill: "#1AE4E6"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4737 33.7461H69.4536V36.0333H69.4737V33.7461Z",
    fill: "#1AE4E6"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4942 33.7461H69.4741V36.0333H69.4942V33.7461Z",
    fill: "#1AE4E6"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4942 33.7461H69.4741V36.0333H69.4942V33.7461Z",
    fill: "#1AE4E6"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5152 33.7461H69.4951V36.0333H69.5152V33.7461Z",
    fill: "#1AE4E6"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5152 33.7461H69.4951V36.0333H69.5152V33.7461Z",
    fill: "#1AE4E6"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5343 33.7461H69.5142V36.0333H69.5343V33.7461Z",
    fill: "#1AE4E6"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5343 33.7461H69.5142V36.0333H69.5343V33.7461Z",
    fill: "#1AE5E6"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5548 33.7461H69.5347V36.0333H69.5548V33.7461Z",
    fill: "#1AE5E6"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5759 33.7461H69.5557V36.0333H69.5759V33.7461Z",
    fill: "#1AE5E6"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5759 33.7461H69.5557V36.0333H69.5759V33.7461Z",
    fill: "#1AE5E6"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5953 33.7461H69.5752V36.0333H69.5953V33.7461Z",
    fill: "#1AE5E6"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5953 33.7461H69.5752V36.0333H69.5953V33.7461Z",
    fill: "#1AE5E6"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6144 33.7461H69.5942V36.0333H69.6144V33.7461Z",
    fill: "#1AE5E6"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6144 33.7461H69.5942V36.0333H69.6144V33.7461Z",
    fill: "#1AE5E6"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6354 33.7461H69.6152V36.0333H69.6354V33.7461Z",
    fill: "#1AE5E6"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6354 33.7461H69.6152V36.0333H69.6354V33.7461Z",
    fill: "#1AE5E6"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6559 33.7461H69.6357V36.0333H69.6559V33.7461Z",
    fill: "#1AE5E6"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6559 33.7461H69.6357V36.0333H69.6559V33.7461Z",
    fill: "#1AE5E6"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6768 33.7461H69.6567V36.0333H69.6768V33.7461Z",
    fill: "#1AE5E6"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6964 33.7461H69.6763V36.0333H69.6964V33.7461Z",
    fill: "#1AE6E6"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6964 33.7461H69.6763V36.0333H69.6964V33.7461Z",
    fill: "#1AE6E6"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7165 33.7461H69.6963V36.0333H69.7165V33.7461Z",
    fill: "#1AE6E6"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7165 33.7461H69.6963V36.0333H69.7165V33.7461Z",
    fill: "#1AE6E6"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7364 33.7461H69.7163V36.0333H69.7364V33.7461Z",
    fill: "#1AE6E6"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7364 33.7461H69.7163V36.0333H69.7364V33.7461Z",
    fill: "#1AE6E6"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7569 33.7461H69.7368V36.0333H69.7569V33.7461Z",
    fill: "#1AE6E6"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7569 33.7461H69.7368V36.0333H69.7569V33.7461Z",
    fill: "#1AE6E6"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7784 33.7461H69.7583V36.0333H69.7784V33.7461Z",
    fill: "#1AE6E6"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7784 33.7461H69.7583V36.0333H69.7784V33.7461Z",
    fill: "#1AE6E6"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7985 33.7461H69.7783V36.0333H69.7985V33.7461Z",
    fill: "#1AE6E6"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8175 33.7461H69.7974V36.0333H69.8175V33.7461Z",
    fill: "#1AE6E6"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8175 33.7461H69.7974V36.0333H69.8175V33.7461Z",
    fill: "#1AE6E6"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8375 33.7461H69.8174V36.0333H69.8375V33.7461Z",
    fill: "#1AE6E6"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8375 33.7461H69.8174V36.0333H69.8375V33.7461Z",
    fill: "#1AE6E6"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8581 33.7461H69.8379V36.0333H69.8581V33.7461Z",
    fill: "#1AE6E6"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8581 33.7461H69.8379V36.0333H69.8581V33.7461Z",
    fill: "#1AE6E6"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M69.879 33.7461H69.8589V36.0333H69.879V33.7461Z",
    fill: "#1AE6E6"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M69.879 33.7461H69.8589V36.0333H69.879V33.7461Z",
    fill: "#1AE6E6"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8981 33.7461H69.8779V36.0333H69.8981V33.7461Z",
    fill: "#1AE6E6"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8981 33.7461H69.8779V36.0333H69.8981V33.7461Z",
    fill: "#1AE6E6"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9195 33.7461H69.8994V36.0333H69.9195V33.7461Z",
    fill: "#1AE6E6"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9386 33.7461H69.9185V36.0333H69.9386V33.7461Z",
    fill: "#1AE6E6"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9386 33.7461H69.9185V36.0333H69.9386V33.7461Z",
    fill: "#1AE6E6"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9601 33.7461H69.9399V36.0333H69.9601V33.7461Z",
    fill: "#1AE6E6"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9601 33.7461H69.9399V36.0333H69.9601V33.7461Z",
    fill: "#1AE6E6"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9801 33.7461H69.96V36.0333H69.9801V33.7461Z",
    fill: "#1AE6E6"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9801 33.7461H69.96V36.0333H69.9801V33.7461Z",
    fill: "#1AE6E6"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0001 33.7461H69.98V36.0333H70.0001V33.7461Z",
    fill: "#1AE6E6"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0001 33.7461H69.98V36.0333H70.0001V33.7461Z",
    fill: "#1AE6E6"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1905 11.0742H56.1704V13.3615H56.1905V11.0742Z",
    fill: "#0017BF"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2091 11.0742H56.189V13.3615H56.2091V11.0742Z",
    fill: "#001AC0"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2091 11.0742H56.189V13.3615H56.2091V11.0742Z",
    fill: "#011DC0"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2301 11.0742H56.21V13.3615H56.2301V11.0742Z",
    fill: "#0120C1"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2301 11.0742H56.21V13.3615H56.2301V11.0742Z",
    fill: "#0223C1"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2511 11.0742H56.231V13.3615H56.2511V11.0742Z",
    fill: "#0226C2"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2511 11.0742H56.231V13.3615H56.2511V11.0742Z",
    fill: "#0229C2"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2701 11.0742H56.25V13.3615H56.2701V11.0742Z",
    fill: "#032CC3"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2701 11.0742H56.25V13.3615H56.2701V11.0742Z",
    fill: "#032FC4"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2911 11.0742H56.271V13.3615H56.2911V11.0742Z",
    fill: "#0332C4"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2911 11.0742H56.271V13.3615H56.2911V11.0742Z",
    fill: "#0435C5"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3126 11.0742H56.2925V13.3615H56.3126V11.0742Z",
    fill: "#0437C5"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3326 11.0742H56.3125V13.3615H56.3326V11.0742Z",
    fill: "#043AC6"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3326 11.0742H56.3125V13.3615H56.3326V11.0742Z",
    fill: "#053DC6"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3526 11.0742H56.3325V13.3615H56.3526V11.0742Z",
    fill: "#0540C7"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3526 11.0742H56.3325V13.3615H56.3526V11.0742Z",
    fill: "#0542C7"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3722 11.0742H56.3521V13.3615H56.3722V11.0742Z",
    fill: "#0645C8"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3722 11.0742H56.3521V13.3615H56.3722V11.0742Z",
    fill: "#0648C8"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3932 11.0742H56.373V13.3615H56.3932V11.0742Z",
    fill: "#064AC9"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3932 11.0742H56.373V13.3615H56.3932V11.0742Z",
    fill: "#074DC9"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4127 11.0742H56.3926V13.3615H56.4127V11.0742Z",
    fill: "#074FCA"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4127 11.0742H56.3926V13.3615H56.4127V11.0742Z",
    fill: "#0752CA"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4337 11.0742H56.4136V13.3615H56.4337V11.0742Z",
    fill: "#0854CB"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4538 11.0742H56.4336V13.3615H56.4538V11.0742Z",
    fill: "#0857CB"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4538 11.0742H56.4336V13.3615H56.4538V11.0742Z",
    fill: "#0859CB"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4752 11.0742H56.4551V13.3615H56.4752V11.0742Z",
    fill: "#095CCC"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4752 11.0742H56.4551V13.3615H56.4752V11.0742Z",
    fill: "#095ECC"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4942 11.0742H56.4741V13.3615H56.4942V11.0742Z",
    fill: "#0960CD"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4942 11.0742H56.4741V13.3615H56.4942V11.0742Z",
    fill: "#0963CD"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5148 11.0742H56.4946V13.3615H56.5148V11.0742Z",
    fill: "#0A65CE"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5148 11.0742H56.4946V13.3615H56.5148V11.0742Z",
    fill: "#0A67CE"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5338 11.0742H56.5137V13.3615H56.5338V11.0742Z",
    fill: "#0A69CF"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5338 11.0742H56.5137V13.3615H56.5338V11.0742Z",
    fill: "#0B6BCF"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5553 11.0742H56.5352V13.3615H56.5553V11.0742Z",
    fill: "#0B6ECF"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5763 11.0742H56.5562V13.3615H56.5763V11.0742Z",
    fill: "#0B70D0"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5763 11.0742H56.5562V13.3615H56.5763V11.0742Z",
    fill: "#0B72D0"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5954 11.0742H56.5752V13.3615H56.5954V11.0742Z",
    fill: "#0C74D1"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5954 11.0742H56.5752V13.3615H56.5954V11.0742Z",
    fill: "#0C76D1"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6168 11.0742H56.5967V13.3615H56.6168V11.0742Z",
    fill: "#0C78D1"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6168 11.0742H56.5967V13.3615H56.6168V11.0742Z",
    fill: "#0C7AD2"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6368 11.0742H56.6167V13.3615H56.6368V11.0742Z",
    fill: "#0D7CD2"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6368 11.0742H56.6167V13.3615H56.6368V11.0742Z",
    fill: "#0D7ED2"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6573 11.0742H56.6372V13.3615H56.6573V11.0742Z",
    fill: "#0D80D3"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6573 11.0742H56.6372V13.3615H56.6573V11.0742Z",
    fill: "#0D82D3"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6774 11.0742H56.6572V13.3615H56.6774V11.0742Z",
    fill: "#0E84D4"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6974 11.0742H56.6772V13.3615H56.6974V11.0742Z",
    fill: "#0E86D4"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6974 11.0742H56.6772V13.3615H56.6974V11.0742Z",
    fill: "#0E88D4"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7179 11.0742H56.6978V13.3615H56.7179V11.0742Z",
    fill: "#0E89D5"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7179 11.0742H56.6978V13.3615H56.7179V11.0742Z",
    fill: "#0F8BD5"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7379 11.0742H56.7178V13.3615H56.7379V11.0742Z",
    fill: "#0F8DD5"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7379 11.0742H56.7178V13.3615H56.7379V11.0742Z",
    fill: "#0F8FD6"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7579 11.0742H56.7378V13.3615H56.7579V11.0742Z",
    fill: "#0F90D6"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7579 11.0742H56.7378V13.3615H56.7579V11.0742Z",
    fill: "#0F92D6"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7774 11.0742H56.7573V13.3615H56.7774V11.0742Z",
    fill: "#1094D7"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7774 11.0742H56.7573V13.3615H56.7774V11.0742Z",
    fill: "#1095D7"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7984 11.0742H56.7783V13.3615H56.7984V11.0742Z",
    fill: "#1097D7"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8185 11.0742H56.7983V13.3615H56.8185V11.0742Z",
    fill: "#1099D7"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8185 11.0742H56.7983V13.3615H56.8185V11.0742Z",
    fill: "#109AD8"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8391 11.0742H56.8188V13.3615H56.8391V11.0742Z",
    fill: "#119CD8"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8391 11.0742H56.8188V13.3615H56.8391V11.0742Z",
    fill: "#119DD8"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M56.86 11.0742H56.8398V13.3615H56.86V11.0742Z",
    fill: "#119FD9"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M56.86 11.0742H56.8398V13.3615H56.86V11.0742Z",
    fill: "#11A0D9"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M56.879 11.0742H56.8589V13.3615H56.879V11.0742Z",
    fill: "#11A2D9"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M56.879 11.0742H56.8589V13.3615H56.879V11.0742Z",
    fill: "#12A3D9"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8995 11.0742H56.8794V13.3615H56.8995V11.0742Z",
    fill: "#12A5DA"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8995 11.0742H56.8794V13.3615H56.8995V11.0742Z",
    fill: "#12A6DA"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9195 11.0742H56.8994V13.3615H56.9195V11.0742Z",
    fill: "#12A8DA"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9401 11.0742H56.9199V13.3615H56.9401V11.0742Z",
    fill: "#12A9DB"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9401 11.0742H56.9199V13.3615H56.9401V11.0742Z",
    fill: "#13AADB"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9601 11.0742H56.9399V13.3615H56.9601V11.0742Z",
    fill: "#13ACDB"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9601 11.0742H56.9399V13.3615H56.9601V11.0742Z",
    fill: "#13ADDB"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9801 11.0742H56.96V13.3615H56.9801V11.0742Z",
    fill: "#13AEDC"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9801 11.0742H56.96V13.3615H56.9801V11.0742Z",
    fill: "#13B0DC"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9997 11.0742H56.9795V13.3615H56.9997V11.0742Z",
    fill: "#13B1DC"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9997 11.0742H56.9795V13.3615H56.9997V11.0742Z",
    fill: "#13B2DC"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0216 11.0742H57.0015V13.3615H57.0216V11.0742Z",
    fill: "#14B3DC"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0216 11.0742H57.0015V13.3615H57.0216V11.0742Z",
    fill: "#14B4DD"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0421 11.0742H57.022V13.3615H57.0421V11.0742Z",
    fill: "#14B6DD"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0621 11.0742H57.042V13.3615H57.0621V11.0742Z",
    fill: "#14B7DD"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0621 11.0742H57.042V13.3615H57.0621V11.0742Z",
    fill: "#14B8DD"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0821 11.0742H57.062V13.3615H57.0821V11.0742Z",
    fill: "#14B9DE"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0821 11.0742H57.062V13.3615H57.0821V11.0742Z",
    fill: "#14BADE"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1012 11.0742H57.0811V13.3615H57.1012V11.0742Z",
    fill: "#15BBDE"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1012 11.0742H57.0811V13.3615H57.1012V11.0742Z",
    fill: "#15BCDE"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1226 11.0742H57.1025V13.3615H57.1226V11.0742Z",
    fill: "#15BDDE"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1226 11.0742H57.1025V13.3615H57.1226V11.0742Z",
    fill: "#15BEDF"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1417 11.0742H57.1216V13.3615H57.1417V11.0742Z",
    fill: "#15BFDF"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1417 11.0742H57.1216V13.3615H57.1417V11.0742Z",
    fill: "#15C0DF"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1622 11.0742H57.1421V13.3615H57.1622V11.0742Z",
    fill: "#15C1DF"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1832 11.0742H57.1631V13.3615H57.1832V11.0742Z",
    fill: "#16C2DF"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1832 11.0742H57.1631V13.3615H57.1832V11.0742Z",
    fill: "#16C3DF"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2027 11.0742H57.1826V13.3615H57.2027V11.0742Z",
    fill: "#16C4E0"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2027 11.0742H57.1826V13.3615H57.2027V11.0742Z",
    fill: "#16C5E0"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2242 11.0742H57.2041V13.3615H57.2242V11.0742Z",
    fill: "#16C6E0"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2242 11.0742H57.2041V13.3615H57.2242V11.0742Z",
    fill: "#16C7E0"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2438 11.0742H57.2236V13.3615H57.2438V11.0742Z",
    fill: "#16C8E0"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2438 11.0742H57.2236V13.3615H57.2438V11.0742Z",
    fill: "#16C9E0"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2643 11.0742H57.2441V13.3615H57.2643V11.0742Z",
    fill: "#16C9E1"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2643 11.0742H57.2441V13.3615H57.2643V11.0742Z",
    fill: "#17CAE1"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2833 11.0742H57.2632V13.3615H57.2833V11.0742Z",
    fill: "#17CBE1"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3038 11.0742H57.2837V13.3615H57.3038V11.0742Z",
    fill: "#17CCE1"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3038 11.0742H57.2837V13.3615H57.3038V11.0742Z",
    fill: "#17CCE1"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3259 11.0742H57.3057V13.3615H57.3259V11.0742Z",
    fill: "#17CDE1"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3259 11.0742H57.3057V13.3615H57.3259V11.0742Z",
    fill: "#17CEE1"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3448 11.0742H57.3247V13.3615H57.3448V11.0742Z",
    fill: "#17CFE2"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3448 11.0742H57.3247V13.3615H57.3448V11.0742Z",
    fill: "#17CFE2"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3653 11.0742H57.3452V13.3615H57.3653V11.0742Z",
    fill: "#17D0E2"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3653 11.0742H57.3452V13.3615H57.3653V11.0742Z",
    fill: "#17D1E2"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3845 11.0742H57.3643V13.3615H57.3845V11.0742Z",
    fill: "#17D1E2"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3845 11.0742H57.3643V13.3615H57.3845V11.0742Z",
    fill: "#17D2E2"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4059 11.0742H57.3857V13.3615H57.4059V11.0742Z",
    fill: "#18D3E2"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4258 11.0742H57.4058V13.3615H57.4258V11.0742Z",
    fill: "#18D3E2"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4258 11.0742H57.4058V13.3615H57.4258V11.0742Z",
    fill: "#18D4E3"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4469 11.0742H57.4268V13.3615H57.4469V11.0742Z",
    fill: "#18D4E3"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4469 11.0742H57.4268V13.3615H57.4469V11.0742Z",
    fill: "#18D5E3"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4665 11.0742H57.4463V13.3615H57.4665V11.0742Z",
    fill: "#18D6E3"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4665 11.0742H57.4463V13.3615H57.4665V11.0742Z",
    fill: "#18D6E3"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4864 11.0742H57.4663V13.3615H57.4864V11.0742Z",
    fill: "#18D7E3"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4864 11.0742H57.4663V13.3615H57.4864V11.0742Z",
    fill: "#18D7E3"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5069 11.0742H57.4868V13.3615H57.5069V11.0742Z",
    fill: "#18D8E3"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5069 11.0742H57.4868V13.3615H57.5069V11.0742Z",
    fill: "#18D8E3"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M57.527 11.0742H57.5068V13.3615H57.527V11.0742Z",
    fill: "#18D9E4"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M57.547 11.0742H57.5269V13.3615H57.547V11.0742Z",
    fill: "#18D9E4"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M57.547 11.0742H57.5269V13.3615H57.547V11.0742Z",
    fill: "#18DAE4"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M57.567 11.0742H57.5469V13.3615H57.567V11.0742Z",
    fill: "#19DAE4"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M57.567 11.0742H57.5469V13.3615H57.567V11.0742Z",
    fill: "#19DBE4"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5875 11.0742H57.5674V13.3615H57.5875V11.0742Z",
    fill: "#19DBE4"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5875 11.0742H57.5674V13.3615H57.5875V11.0742Z",
    fill: "#19DBE4"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M57.609 11.0742H57.5889V13.3615H57.609V11.0742Z",
    fill: "#19DCE4"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M57.609 11.0742H57.5889V13.3615H57.609V11.0742Z",
    fill: "#19DCE4"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M57.629 11.0742H57.6089V13.3615H57.629V11.0742Z",
    fill: "#19DDE4"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M57.629 11.0742H57.6089V13.3615H57.629V11.0742Z",
    fill: "#19DDE4"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M57.649 11.0742H57.6289V13.3615H57.649V11.0742Z",
    fill: "#19DDE4"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M57.668 11.0742H57.6479V13.3615H57.668V11.0742Z",
    fill: "#19DEE4"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M57.668 11.0742H57.6479V13.3615H57.668V11.0742Z",
    fill: "#19DEE5"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6896 11.0742H57.6694V13.3615H57.6896V11.0742Z",
    fill: "#19DEE5"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6896 11.0742H57.6694V13.3615H57.6896V11.0742Z",
    fill: "#19DFE5"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7086 11.0742H57.6885V13.3615H57.7086V11.0742Z",
    fill: "#19DFE5"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7086 11.0742H57.6885V13.3615H57.7086V11.0742Z",
    fill: "#19DFE5"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7301 11.0742H57.71V13.3615H57.7301V11.0742Z",
    fill: "#19E0E5"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7301 11.0742H57.71V13.3615H57.7301V11.0742Z",
    fill: "#19E0E5"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7501 11.0742H57.73V13.3615H57.7501V11.0742Z",
    fill: "#19E0E5"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7501 11.0742H57.73V13.3615H57.7501V11.0742Z",
    fill: "#19E1E5"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7702 11.0742H57.75V13.3615H57.7702V11.0742Z",
    fill: "#19E1E5"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7906 11.0742H57.7705V13.3615H57.7906V11.0742Z",
    fill: "#19E1E5"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7906 11.0742H57.7705V13.3615H57.7906V11.0742Z",
    fill: "#19E1E5"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8106 11.0742H57.7905V13.3615H57.8106V11.0742Z",
    fill: "#19E2E5"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8106 11.0742H57.7905V13.3615H57.8106V11.0742Z",
    fill: "#19E2E5"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8312 11.0742H57.811V13.3615H57.8312V11.0742Z",
    fill: "#19E2E5"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8312 11.0742H57.811V13.3615H57.8312V11.0742Z",
    fill: "#1AE2E5"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8502 11.0742H57.8301V13.3615H57.8502V11.0742Z",
    fill: "#1AE2E5"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8502 11.0742H57.8301V13.3615H57.8502V11.0742Z",
    fill: "#1AE3E5"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8713 11.0742H57.8511V13.3615H57.8713V11.0742Z",
    fill: "#1AE3E5"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8713 11.0742H57.8511V13.3615H57.8713V11.0742Z",
    fill: "#1AE3E5"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8927 11.0742H57.8726V13.3615H57.8927V11.0742Z",
    fill: "#1AE3E5"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9117 11.0742H57.8916V13.3615H57.9117V11.0742Z",
    fill: "#1AE3E5"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9117 11.0742H57.8916V13.3615H57.9117V11.0742Z",
    fill: "#1AE3E6"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9322 11.0742H57.9121V13.3615H57.9322V11.0742Z",
    fill: "#1AE4E6"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9322 11.0742H57.9121V13.3615H57.9322V11.0742Z",
    fill: "#1AE4E6"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9513 11.0742H57.9312V13.3615H57.9513V11.0742Z",
    fill: "#1AE4E6"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9513 11.0742H57.9312V13.3615H57.9513V11.0742Z",
    fill: "#1AE4E6"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9732 11.0742H57.9531V13.3615H57.9732V11.0742Z",
    fill: "#1AE4E6"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9732 11.0742H57.9531V13.3615H57.9732V11.0742Z",
    fill: "#1AE4E6"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9928 11.0742H57.9727V13.3615H57.9928V11.0742Z",
    fill: "#1AE4E6"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9928 11.0742H57.9727V13.3615H57.9928V11.0742Z",
    fill: "#1AE5E6"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0138 11.0742H57.9937V13.3615H58.0138V11.0742Z",
    fill: "#1AE5E6"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0333 11.0742H58.0132V13.3615H58.0333V11.0742Z",
    fill: "#1AE5E6"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0333 11.0742H58.0132V13.3615H58.0333V11.0742Z",
    fill: "#1AE5E6"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0533 11.0742H58.0332V13.3615H58.0533V11.0742Z",
    fill: "#1AE5E6"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0533 11.0742H58.0332V13.3615H58.0533V11.0742Z",
    fill: "#1AE5E6"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0743 11.0742H58.0542V13.3615H58.0743V11.0742Z",
    fill: "#1AE5E6"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0743 11.0742H58.0542V13.3615H58.0743V11.0742Z",
    fill: "#1AE5E6"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0934 11.0742H58.0732V13.3615H58.0934V11.0742Z",
    fill: "#1AE5E6"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0934 11.0742H58.0732V13.3615H58.0934V11.0742Z",
    fill: "#1AE5E6"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1138 11.0742H58.0938V13.3615H58.1138V11.0742Z",
    fill: "#1AE5E6"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1138 11.0742H58.0938V13.3615H58.1138V11.0742Z",
    fill: "#1AE5E6"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1349 11.0742H58.1147V13.3615H58.1349V11.0742Z",
    fill: "#1AE5E6"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1545 11.0742H58.1343V13.3615H58.1545V11.0742Z",
    fill: "#1AE6E6"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1545 11.0742H58.1343V13.3615H58.1545V11.0742Z",
    fill: "#1AE6E6"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1755 11.0742H58.1553V13.3615H58.1755V11.0742Z",
    fill: "#1AE6E6"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1755 11.0742H58.1553V13.3615H58.1755V11.0742Z",
    fill: "#1AE6E6"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1954 11.0742H58.1753V13.3615H58.1954V11.0742Z",
    fill: "#1AE6E6"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1954 11.0742H58.1753V13.3615H58.1954V11.0742Z",
    fill: "#1AE6E6"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2159 11.0742H58.1958V13.3615H58.2159V11.0742Z",
    fill: "#1AE6E6"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2159 11.0742H58.1958V13.3615H58.2159V11.0742Z",
    fill: "#1AE6E6"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M58.236 11.0742H58.2158V13.3615H58.236V11.0742Z",
    fill: "#1AE6E6"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M58.236 11.0742H58.2158V13.3615H58.236V11.0742Z",
    fill: "#1AE6E6"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2565 11.0742H58.2363V13.3615H58.2565V11.0742Z",
    fill: "#1AE6E6"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2765 11.0742H58.2563V13.3615H58.2765V11.0742Z",
    fill: "#1AE6E6"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2765 11.0742H58.2563V13.3615H58.2765V11.0742Z",
    fill: "#1AE6E6"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M58.297 11.0742H58.2769V13.3615H58.297V11.0742Z",
    fill: "#1AE6E6"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M58.297 11.0742H58.2769V13.3615H58.297V11.0742Z",
    fill: "#1AE6E6"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3161 11.0742H58.2959V13.3615H58.3161V11.0742Z",
    fill: "#1AE6E6"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3161 11.0742H58.2959V13.3615H58.3161V11.0742Z",
    fill: "#1AE6E6"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M58.337 11.0742H58.3169V13.3615H58.337V11.0742Z",
    fill: "#1AE6E6"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M58.337 11.0742H58.3169V13.3615H58.337V11.0742Z",
    fill: "#1AE6E6"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3575 11.0742H58.3374V13.3615H58.3575V11.0742Z",
    fill: "#1AE6E6"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3575 11.0742H58.3374V13.3615H58.3575V11.0742Z",
    fill: "#1AE6E6"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3775 11.0742H58.3574V13.3615H58.3775V11.0742Z",
    fill: "#1AE6E6"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3976 11.0742H58.3774V13.3615H58.3976V11.0742Z",
    fill: "#1AE6E6"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3976 11.0742H58.3774V13.3615H58.3976V11.0742Z",
    fill: "#1AE6E6"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4181 11.0742H58.3979V13.3615H58.4181V11.0742Z",
    fill: "#1AE6E6"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4181 11.0742H58.3979V13.3615H58.4181V11.0742Z",
    fill: "#1AE6E6"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4391 11.0742H58.4189V13.3615H58.4391V11.0742Z",
    fill: "#1AE6E6"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4391 11.0742H58.4189V13.3615H58.4391V11.0742Z",
    fill: "#1AE6E6"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4586 11.0742H58.4385V13.3615H58.4586V11.0742Z",
    fill: "#1AE6E6"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4586 11.0742H58.4385V13.3615H58.4586V11.0742Z",
    fill: "#1AE6E6"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93761 39.0078H2.91748V41.2951H2.93761V39.0078Z",
    fill: "#0017BF"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95715 39.0078H2.93701V41.2951H2.95715V39.0078Z",
    fill: "#001AC0"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95715 39.0078H2.93701V41.2951H2.95715V39.0078Z",
    fill: "#011DC0"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97765 39.0078H2.95752V41.2951H2.97765V39.0078Z",
    fill: "#0120C1"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97765 39.0078H2.95752V41.2951H2.97765V39.0078Z",
    fill: "#0223C1"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00159 39.0078H2.98145V41.2951H3.00159V39.0078Z",
    fill: "#0226C2"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00159 39.0078H2.98145V41.2951H3.00159V39.0078Z",
    fill: "#0229C2"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01719 39.0078H2.99707V41.2951H3.01719V39.0078Z",
    fill: "#032CC3"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01719 39.0078H2.99707V41.2951H3.01719V39.0078Z",
    fill: "#032FC4"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0382 39.0078H3.01807V41.2951H3.0382V39.0078Z",
    fill: "#0332C4"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0382 39.0078H3.01807V41.2951H3.0382V39.0078Z",
    fill: "#0435C5"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0587 39.0078H3.03857V41.2951H3.0587V39.0078Z",
    fill: "#0437C5"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0792 39.0078H3.05908V41.2951H3.0792V39.0078Z",
    fill: "#043AC6"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0792 39.0078H3.05908V41.2951H3.0792V39.0078Z",
    fill: "#053DC6"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09826 39.0078H3.07812V41.2951H3.09826V39.0078Z",
    fill: "#0540C7"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09826 39.0078H3.07812V41.2951H3.09826V39.0078Z",
    fill: "#0542C7"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11925 39.0078H3.09912V41.2951H3.11925V39.0078Z",
    fill: "#0645C8"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11925 39.0078H3.09912V41.2951H3.11925V39.0078Z",
    fill: "#0648C8"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13978 39.0078H3.11963V41.2951H3.13978V39.0078Z",
    fill: "#064AC9"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13978 39.0078H3.11963V41.2951H3.13978V39.0078Z",
    fill: "#074DC9"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16076 39.0078H3.14062V41.2951H3.16076V39.0078Z",
    fill: "#074FCA"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16076 39.0078H3.14062V41.2951H3.16076V39.0078Z",
    fill: "#0752CA"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18077 39.0078H3.16064V41.2951H3.18077V39.0078Z",
    fill: "#0854CB"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20031 39.0078H3.18018V41.2951H3.20031V39.0078Z",
    fill: "#0857CB"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20031 39.0078H3.18018V41.2951H3.20031V39.0078Z",
    fill: "#0859CB"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22131 39.0078H3.20117V41.2951H3.22131V39.0078Z",
    fill: "#095CCC"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22131 39.0078H3.20117V41.2951H3.22131V39.0078Z",
    fill: "#095ECC"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24085 39.0078H3.2207V41.2951H3.24085V39.0078Z",
    fill: "#0960CD"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24085 39.0078H3.2207V41.2951H3.24085V39.0078Z",
    fill: "#0963CD"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26183 39.0078H3.2417V41.2951H3.26183V39.0078Z",
    fill: "#0A65CE"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26183 39.0078H3.2417V41.2951H3.26183V39.0078Z",
    fill: "#0A67CE"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28086 39.0078H3.26074V41.2951H3.28086V39.0078Z",
    fill: "#0A69CF"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28086 39.0078H3.26074V41.2951H3.28086V39.0078Z",
    fill: "#0B6BCF"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3014 39.0078H3.28125V41.2951H3.3014V39.0078Z",
    fill: "#0B6ECF"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32237 39.0078H3.30225V41.2951H3.32237V39.0078Z",
    fill: "#0B70D0"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32237 39.0078H3.30225V41.2951H3.32237V39.0078Z",
    fill: "#0B72D0"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3424 39.0078H3.32227V41.2951H3.3424V39.0078Z",
    fill: "#0C74D1"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3424 39.0078H3.32227V41.2951H3.3424V39.0078Z",
    fill: "#0C76D1"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36289 39.0078H3.34277V41.2951H3.36289V39.0078Z",
    fill: "#0C78D1"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36289 39.0078H3.34277V41.2951H3.36289V39.0078Z",
    fill: "#0C7AD2"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38293 39.0078H3.36279V41.2951H3.38293V39.0078Z",
    fill: "#0D7CD2"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38293 39.0078H3.36279V41.2951H3.38293V39.0078Z",
    fill: "#0D7ED2"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40343 39.0078H3.3833V41.2951H3.40343V39.0078Z",
    fill: "#0D80D3"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40343 39.0078H3.3833V41.2951H3.40343V39.0078Z",
    fill: "#0D82D3"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42344 39.0078H3.40332V41.2951H3.42344V39.0078Z",
    fill: "#0E84D4"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44347 39.0078H3.42334V41.2951H3.44347V39.0078Z",
    fill: "#0E86D4"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44347 39.0078H3.42334V41.2951H3.44347V39.0078Z",
    fill: "#0E88D4"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46398 39.0078H3.44385V41.2951H3.46398V39.0078Z",
    fill: "#0E89D5"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46398 39.0078H3.44385V41.2951H3.46398V39.0078Z",
    fill: "#0F8BD5"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48301 39.0078H3.46289V41.2951H3.48301V39.0078Z",
    fill: "#0F8DD5"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48301 39.0078H3.46289V41.2951H3.48301V39.0078Z",
    fill: "#0F8FD6"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50451 39.0078H3.48438V41.2951H3.50451V39.0078Z",
    fill: "#0F90D6"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50451 39.0078H3.48438V41.2951H3.50451V39.0078Z",
    fill: "#0F92D6"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52453 39.0078H3.50439V41.2951H3.52453V39.0078Z",
    fill: "#1094D7"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52453 39.0078H3.50439V41.2951H3.52453V39.0078Z",
    fill: "#1095D7"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54554 39.0078H3.52539V41.2951H3.54554V39.0078Z",
    fill: "#1097D7"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56504 39.0078H3.54492V41.2951H3.56504V39.0078Z",
    fill: "#1099D7"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56504 39.0078H3.54492V41.2951H3.56504V39.0078Z",
    fill: "#109AD8"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58506 39.0078H3.56494V41.2951H3.58506V39.0078Z",
    fill: "#119CD8"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58506 39.0078H3.56494V41.2951H3.58506V39.0078Z",
    fill: "#119DD8"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60657 39.0078H3.58643V41.2951H3.60657V39.0078Z",
    fill: "#119FD9"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60657 39.0078H3.58643V41.2951H3.60657V39.0078Z",
    fill: "#11A0D9"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62559 39.0078H3.60547V41.2951H3.62559V39.0078Z",
    fill: "#11A2D9"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62559 39.0078H3.60547V41.2951H3.62559V39.0078Z",
    fill: "#12A3D9"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6466 39.0078H3.62646V41.2951H3.6466V39.0078Z",
    fill: "#12A5DA"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6466 39.0078H3.62646V41.2951H3.6466V39.0078Z",
    fill: "#12A6DA"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66612 39.0078H3.646V41.2951H3.66612V39.0078Z",
    fill: "#12A8DA"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68615 39.0078H3.66602V41.2951H3.68615V39.0078Z",
    fill: "#12A9DB"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68615 39.0078H3.66602V41.2951H3.68615V39.0078Z",
    fill: "#13AADB"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70717 39.0078H3.68701V41.2951H3.70717V39.0078Z",
    fill: "#13ACDB"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70717 39.0078H3.68701V41.2951H3.70717V39.0078Z",
    fill: "#13ADDB"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72666 39.0078H3.70654V41.2951H3.72666V39.0078Z",
    fill: "#13AEDC"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72666 39.0078H3.70654V41.2951H3.72666V39.0078Z",
    fill: "#13B0DC"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7467 39.0078H3.72656V41.2951H3.7467V39.0078Z",
    fill: "#13B1DC"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7467 39.0078H3.72656V41.2951H3.7467V39.0078Z",
    fill: "#13B2DC"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76719 39.0078H3.74707V41.2951H3.76719V39.0078Z",
    fill: "#14B3DC"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76719 39.0078H3.74707V41.2951H3.76719V39.0078Z",
    fill: "#14B4DD"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7882 39.0078H3.76807V41.2951H3.7882V39.0078Z",
    fill: "#14B6DD"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80871 39.0078H3.78857V41.2951H3.80871V39.0078Z",
    fill: "#14B7DD"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80871 39.0078H3.78857V41.2951H3.80871V39.0078Z",
    fill: "#14B8DD"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82873 39.0078H3.80859V41.2951H3.82873V39.0078Z",
    fill: "#14B9DE"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82873 39.0078H3.80859V41.2951H3.82873V39.0078Z",
    fill: "#14BADE"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84778 39.0078H3.82764V41.2951H3.84778V39.0078Z",
    fill: "#15BBDE"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84778 39.0078H3.82764V41.2951H3.84778V39.0078Z",
    fill: "#15BCDE"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86877 39.0078H3.84863V41.2951H3.86877V39.0078Z",
    fill: "#15BDDE"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86877 39.0078H3.84863V41.2951H3.86877V39.0078Z",
    fill: "#15BEDF"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88828 39.0078H3.86816V41.2951H3.88828V39.0078Z",
    fill: "#15BFDF"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88828 39.0078H3.86816V41.2951H3.88828V39.0078Z",
    fill: "#15C0DF"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90929 39.0078H3.88916V41.2951H3.90929V39.0078Z",
    fill: "#15C1DF"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9298 39.0078H3.90967V41.2951H3.9298V39.0078Z",
    fill: "#16C2DF"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9298 39.0078H3.90967V41.2951H3.9298V39.0078Z",
    fill: "#16C3DF"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94982 39.0078H3.92969V41.2951H3.94982V39.0078Z",
    fill: "#16C4E0"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94982 39.0078H3.92969V41.2951H3.94982V39.0078Z",
    fill: "#16C5E0"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97032 39.0078H3.9502V41.2951H3.97032V39.0078Z",
    fill: "#16C6E0"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97032 39.0078H3.9502V41.2951H3.97032V39.0078Z",
    fill: "#16C7E0"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99035 39.0078H3.97021V41.2951H3.99035V39.0078Z",
    fill: "#16C8E0"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99035 39.0078H3.97021V41.2951H3.99035V39.0078Z",
    fill: "#16C9E0"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01038 39.0078H3.99023V41.2951H4.01038V39.0078Z",
    fill: "#16C9E1"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01038 39.0078H3.99023V41.2951H4.01038V39.0078Z",
    fill: "#17CAE1"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03038 39.0078H4.01025V41.2951H4.03038V39.0078Z",
    fill: "#17CBE1"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04992 39.0078H4.02979V41.2951H4.04992V39.0078Z",
    fill: "#17CCE1"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04992 39.0078H4.02979V41.2951H4.04992V39.0078Z",
    fill: "#17CCE1"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07188 39.0078H4.05176V41.2951H4.07188V39.0078Z",
    fill: "#17CDE1"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07188 39.0078H4.05176V41.2951H4.07188V39.0078Z",
    fill: "#17CEE1"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09142 39.0078H4.07129V41.2951H4.09142V39.0078Z",
    fill: "#17CFE2"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09142 39.0078H4.07129V41.2951H4.09142V39.0078Z",
    fill: "#17CFE2"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11242 39.0078H4.09229V41.2951H4.11242V39.0078Z",
    fill: "#17D0E2"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11242 39.0078H4.09229V41.2951H4.11242V39.0078Z",
    fill: "#17D1E2"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13146 39.0078H4.11133V41.2951H4.13146V39.0078Z",
    fill: "#17D1E2"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13146 39.0078H4.11133V41.2951H4.13146V39.0078Z",
    fill: "#17D2E2"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15198 39.0078H4.13184V41.2951H4.15198V39.0078Z",
    fill: "#18D3E2"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17297 39.0078H4.15283V41.2951H4.17297V39.0078Z",
    fill: "#18D3E2"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17297 39.0078H4.15283V41.2951H4.17297V39.0078Z",
    fill: "#18D4E3"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19248 39.0078H4.17236V41.2951H4.19248V39.0078Z",
    fill: "#18D4E3"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19248 39.0078H4.17236V41.2951H4.19248V39.0078Z",
    fill: "#18D5E3"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21349 39.0078H4.19336V41.2951H4.21349V39.0078Z",
    fill: "#18D6E3"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21349 39.0078H4.19336V41.2951H4.21349V39.0078Z",
    fill: "#18D6E3"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23351 39.0078H4.21338V41.2951H4.23351V39.0078Z",
    fill: "#18D7E3"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23351 39.0078H4.21338V41.2951H4.23351V39.0078Z",
    fill: "#18D7E3"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25304 39.0078H4.23291V41.2951H4.25304V39.0078Z",
    fill: "#18D8E3"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25304 39.0078H4.23291V41.2951H4.25304V39.0078Z",
    fill: "#18D8E3"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27404 39.0078H4.25391V41.2951H4.27404V39.0078Z",
    fill: "#18D9E4"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29406 39.0078H4.27393V41.2951H4.29406V39.0078Z",
    fill: "#18D9E4"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29406 39.0078H4.27393V41.2951H4.29406V39.0078Z",
    fill: "#18DAE4"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3136 39.0078H4.29346V41.2951H4.3136V39.0078Z",
    fill: "#19DAE4"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3136 39.0078H4.29346V41.2951H4.3136V39.0078Z",
    fill: "#19DBE4"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33457 39.0078H4.31445V41.2951H4.33457V39.0078Z",
    fill: "#19DBE4"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33457 39.0078H4.31445V41.2951H4.33457V39.0078Z",
    fill: "#19DBE4"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35509 39.0078H4.33496V41.2951H4.35509V39.0078Z",
    fill: "#19DCE4"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35509 39.0078H4.33496V41.2951H4.35509V39.0078Z",
    fill: "#19DCE4"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37608 39.0078H4.35596V41.2951H4.37608V39.0078Z",
    fill: "#19DDE4"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37608 39.0078H4.35596V41.2951H4.37608V39.0078Z",
    fill: "#19DDE4"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39561 39.0078H4.37549V41.2951H4.39561V39.0078Z",
    fill: "#19DDE4"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41468 39.0078H4.39453V41.2951H4.41468V39.0078Z",
    fill: "#19DEE4"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41468 39.0078H4.39453V41.2951H4.41468V39.0078Z",
    fill: "#19DEE5"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43566 39.0078H4.41553V41.2951H4.43566V39.0078Z",
    fill: "#19DEE5"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43566 39.0078H4.41553V41.2951H4.43566V39.0078Z",
    fill: "#19DFE5"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45569 39.0078H4.43555V41.2951H4.45569V39.0078Z",
    fill: "#19DFE5"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45569 39.0078H4.43555V41.2951H4.45569V39.0078Z",
    fill: "#19DFE5"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47717 39.0078H4.45703V41.2951H4.47717V39.0078Z",
    fill: "#19E0E5"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47717 39.0078H4.45703V41.2951H4.47717V39.0078Z",
    fill: "#19E0E5"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49668 39.0078H4.47656V41.2951H4.49668V39.0078Z",
    fill: "#19E0E5"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49668 39.0078H4.47656V41.2951H4.49668V39.0078Z",
    fill: "#19E1E5"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51672 39.0078H4.49658V41.2951H4.51672V39.0078Z",
    fill: "#19E1E5"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53674 39.0078H4.5166V41.2951H4.53674V39.0078Z",
    fill: "#19E1E5"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53674 39.0078H4.5166V41.2951H4.53674V39.0078Z",
    fill: "#19E1E5"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55726 39.0078H4.53711V41.2951H4.55726V39.0078Z",
    fill: "#19E2E5"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55726 39.0078H4.53711V41.2951H4.55726V39.0078Z",
    fill: "#19E2E5"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57824 39.0078H4.55811V41.2951H4.57824V39.0078Z",
    fill: "#19E2E5"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57824 39.0078H4.55811V41.2951H4.57824V39.0078Z",
    fill: "#1AE2E5"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59727 39.0078H4.57715V41.2951H4.59727V39.0078Z",
    fill: "#1AE2E5"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59727 39.0078H4.57715V41.2951H4.59727V39.0078Z",
    fill: "#1AE3E5"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61779 39.0078H4.59766V41.2951H4.61779V39.0078Z",
    fill: "#1AE3E5"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61779 39.0078H4.59766V41.2951H4.61779V39.0078Z",
    fill: "#1AE3E5"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63877 39.0078H4.61865V41.2951H4.63877V39.0078Z",
    fill: "#1AE3E5"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65832 39.0078H4.63818V41.2951H4.65832V39.0078Z",
    fill: "#1AE3E5"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65832 39.0078H4.63818V41.2951H4.65832V39.0078Z",
    fill: "#1AE3E6"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6793 39.0078H4.65918V41.2951H4.6793V39.0078Z",
    fill: "#1AE4E6"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6793 39.0078H4.65918V41.2951H4.6793V39.0078Z",
    fill: "#1AE4E6"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69836 39.0078H4.67822V41.2951H4.69836V39.0078Z",
    fill: "#1AE4E6"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69836 39.0078H4.67822V41.2951H4.69836V39.0078Z",
    fill: "#1AE4E6"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71888 39.0078H4.69873V41.2951H4.71888V39.0078Z",
    fill: "#1AE4E6"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71888 39.0078H4.69873V41.2951H4.71888V39.0078Z",
    fill: "#1AE4E6"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73887 39.0078H4.71875V41.2951H4.73887V39.0078Z",
    fill: "#1AE4E6"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73887 39.0078H4.71875V41.2951H4.73887V39.0078Z",
    fill: "#1AE5E6"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76037 39.0078H4.74023V41.2951H4.76037V39.0078Z",
    fill: "#1AE5E6"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78135 39.0078H4.76123V41.2951H4.78135V39.0078Z",
    fill: "#1AE5E6"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78135 39.0078H4.76123V41.2951H4.78135V39.0078Z",
    fill: "#1AE5E6"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80039 39.0078H4.78027V41.2951H4.80039V39.0078Z",
    fill: "#1AE5E6"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80039 39.0078H4.78027V41.2951H4.80039V39.0078Z",
    fill: "#1AE5E6"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82043 39.0078H4.80029V41.2951H4.82043V39.0078Z",
    fill: "#1AE5E6"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82043 39.0078H4.80029V41.2951H4.82043V39.0078Z",
    fill: "#1AE5E6"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83996 39.0078H4.81982V41.2951H4.83996V39.0078Z",
    fill: "#1AE5E6"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83996 39.0078H4.81982V41.2951H4.83996V39.0078Z",
    fill: "#1AE5E6"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86097 39.0078H4.84082V41.2951H4.86097V39.0078Z",
    fill: "#1AE5E6"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86097 39.0078H4.84082V41.2951H4.86097V39.0078Z",
    fill: "#1AE5E6"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88145 39.0078H4.86133V41.2951H4.88145V39.0078Z",
    fill: "#1AE5E6"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90147 39.0078H4.88135V41.2951H4.90147V39.0078Z",
    fill: "#1AE6E6"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90147 39.0078H4.88135V41.2951H4.90147V39.0078Z",
    fill: "#1AE6E6"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9215 39.0078H4.90137V41.2951H4.9215V39.0078Z",
    fill: "#1AE6E6"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9215 39.0078H4.90137V41.2951H4.9215V39.0078Z",
    fill: "#1AE6E6"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M4.942 39.0078H4.92188V41.2951H4.942V39.0078Z",
    fill: "#1AE6E6"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M4.942 39.0078H4.92188V41.2951H4.942V39.0078Z",
    fill: "#1AE6E6"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96301 39.0078H4.94287V41.2951H4.96301V39.0078Z",
    fill: "#1AE6E6"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96301 39.0078H4.94287V41.2951H4.96301V39.0078Z",
    fill: "#1AE6E6"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98254 39.0078H4.9624V41.2951H4.98254V39.0078Z",
    fill: "#1AE6E6"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98254 39.0078H4.9624V41.2951H4.98254V39.0078Z",
    fill: "#1AE6E6"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00256 39.0078H4.98242V41.2951H5.00256V39.0078Z",
    fill: "#1AE6E6"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0226 39.0078H5.00244V41.2951H5.0226V39.0078Z",
    fill: "#1AE6E6"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0226 39.0078H5.00244V41.2951H5.0226V39.0078Z",
    fill: "#1AE6E6"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04307 39.0078H5.02295V41.2951H5.04307V39.0078Z",
    fill: "#1AE6E6"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04307 39.0078H5.02295V41.2951H5.04307V39.0078Z",
    fill: "#1AE6E6"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0631 39.0078H5.04297V41.2951H5.0631V39.0078Z",
    fill: "#1AE6E6"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0631 39.0078H5.04297V41.2951H5.0631V39.0078Z",
    fill: "#1AE6E6"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08359 39.0078H5.06348V41.2951H5.08359V39.0078Z",
    fill: "#1AE6E6"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08359 39.0078H5.06348V41.2951H5.08359V39.0078Z",
    fill: "#1AE6E6"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10363 39.0078H5.0835V41.2951H5.10363V39.0078Z",
    fill: "#1AE6E6"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10363 39.0078H5.0835V41.2951H5.10363V39.0078Z",
    fill: "#1AE6E6"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12463 39.0078H5.10449V41.2951H5.12463V39.0078Z",
    fill: "#1AE6E6"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14414 39.0078H5.12402V41.2951H5.14414V39.0078Z",
    fill: "#1AE6E6"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14414 39.0078H5.12402V41.2951H5.14414V39.0078Z",
    fill: "#1AE6E6"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16517 39.0078H5.14502V41.2951H5.16517V39.0078Z",
    fill: "#1AE6E6"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16517 39.0078H5.14502V41.2951H5.16517V39.0078Z",
    fill: "#1AE6E6"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18566 39.0078H5.16553V41.2951H5.18566V39.0078Z",
    fill: "#1AE6E6"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18566 39.0078H5.16553V41.2951H5.18566V39.0078Z",
    fill: "#1AE6E6"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20469 39.0078H5.18457V41.2951H5.20469V39.0078Z",
    fill: "#1AE6E6"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20469 39.0078H5.18457V41.2951H5.20469V39.0078Z",
    fill: "#1AE6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.17116,
    y1: 50.2966,
    x2: 66.0742,
    y2: 50.2966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0000C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 59.2082,
    y1: 16.9278,
    x2: 66.1341,
    y2: 18.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0338667,
    stopColor: "#032CC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#0857CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1983,
    stopColor: "#0D7ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "#119ED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3859,
    stopColor: "#14B8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4921,
    stopColor: "#17CDE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6122,
    stopColor: "#19DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7579,
    stopColor: "#1AE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AE6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 46.3845,
    y1: 4.68597,
    x2: 53.5135,
    y2: 4.09137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0338667,
    stopColor: "#032CC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#0857CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1983,
    stopColor: "#0D7ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "#119ED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3859,
    stopColor: "#14B8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4921,
    stopColor: "#17CDE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6122,
    stopColor: "#19DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7579,
    stopColor: "#1AE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AE6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 13.042,
    y1: 15.1099,
    x2: 14.494,
    y2: 8.10823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0338667,
    stopColor: "#032CC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#0857CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1983,
    stopColor: "#0D7ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "#119ED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3859,
    stopColor: "#14B8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4921,
    stopColor: "#17CDE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6122,
    stopColor: "#19DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7579,
    stopColor: "#1AE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AE6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 4.45802,
    y1: 27.6377,
    x2: 2.51138,
    y2: 20.7561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0338667,
    stopColor: "#032CC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#0857CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1983,
    stopColor: "#0D7ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "#119ED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3859,
    stopColor: "#14B8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4921,
    stopColor: "#17CDE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6122,
    stopColor: "#19DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7579,
    stopColor: "#1AE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AE6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 27.144,
    y1: 7.69945,
    x2: 31.5021,
    y2: 2.02852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0338667,
    stopColor: "#032CC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#0857CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1983,
    stopColor: "#0D7ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "#119ED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3859,
    stopColor: "#14B8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4921,
    stopColor: "#17CDE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6122,
    stopColor: "#19DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7579,
    stopColor: "#1AE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AE6E6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteDriverSuccess);
export default __webpack_public_path__ + "static/media/inviteDriverSuccess.86de5b916cd42efb848825e593f51d58.svg";
export { ForwardRef as ReactComponent };